import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ConfService } from '../conf.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatIconRegistry, MatSnackBar, MatStepper } from '@angular/material';
import { environment } from '../../environments/environment';
import { ConnecttocrudService } from '../connecttocrud.service';
import { KongService } from '../kong.service';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxXml2jsonService } from 'ngx-xml2json';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogData } from '../partner-onboard/partner-onboard.component';
import { Location } from '@angular/common';
import { AppComponent } from '../app.component';
import { DialogComponent } from '../shared/dialog/dialog.component';
import { ListenerService } from '../listener.service';
import { AddGatewayResourceComponent, LeftpanelComponent, LoaderWithProgressComponent } from '../leftpanel/leftpanel.component';
import { DataaccessListenerService } from '../dataaccess-listener.service';
import { GuidedTour, GuidedTourService, Orientation } from 'ngx-guided-tour';
import { WebsocketService } from '../websocket.service';
import { ApiCreatorsService } from '../api-creators.service';
import { AuditListenerService } from '../audit-listener.service';
import {AccountInfoService} from '../user/account-info.service';
import {AuditLogService} from '../audit-log.service';


export interface ICategory {
    name: string;
}

export interface EntityVersions {
    name: string;
}

export interface MethodTypes {
    id: string;
    itemName: string;
}

declare let $;
const incr = 5;

@Component({
    selector: 'app-crudapi',
    templateUrl: './crudapi.component.html',
    styleUrls: ['./crudapi.component.css']
})
export class CrudapiComponent implements OnInit {
    myControl = new FormControl();
    progress = 0;
    progressMessage: string;
    apiCategory: string;
    tableName: any;
    tableLabelName = 'Table Name';
    version: string;
    entityName: any;
    countPartnerEntities: any;
    countPartnerAccountEntities: any;
    displayName: string;
    attributeName: string;
    description: string;
    required: boolean;
    importDataDB: boolean;
    listofTables: boolean;
    useReferentialKeys: boolean;
    databaseName: string;
    targetDatabase: string;
    APILoading = false;
    buttonClick = false;
    APILoadingdB = false;
    buttonClickdB = false;
    save: boolean;
    error = true;
    flag: any;
    flagValue = true;
    errorMessage: any;
    dberror = true;
    loading = false;
    Blocks = [];
    destroy: any;
    entityAndVersion: any;
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    apiByDefinition: any;
    authModel: any;
    headers = [];
    queryParams = [];
    requestBody: any;
    prerequisites: any;

    filteredOptions: Observable<ICategory[]>;
    entityVersions: EntityVersions[] = [
        { name: 'v1' },
        { name: 'v2' },
        { name: 'v3' },
        { name: 'v4' },
        { name: 'v5' },
        { name: 'v6' },
        { name: 'v7' },
        { name: 'v8' },
        { name: 'v9' },
        { name: 'v10' }
    ];

    settings = {
        text: 'Select API Method Types *',
        // selectAllText: 'Select All',
        // unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    // methodType: string;
    methodTypes: MethodTypes[] = [
        { id: 'GET', itemName: 'GET' },
        { id: 'PUT', itemName: 'PUT' },
        { id: 'POST', itemName: 'POST' },
        { id: 'DELETE', itemName: 'DELETE' },
        { id: 'PATCH', itemName: 'PATCH' }
    ];

    methodType = [];

    selectDatabase: string;
    selectedDatabaseType: string;
    selectGateway = 'default';
    ispublished = true;

    databases: any;
    datatypes: any;
    apiGateways: any;
    gatewayControl = new FormControl([]);
    dataTypeFilter: any;
    selectedDatatypeFilter: string;
    isSelectedDatabaseNatureNoSQL: any;
    options: any;
    url = environment.konghost;
    attributes = ['None', 'Primary', 'Unique'];
    data = ['String',
        'Integer',
        'Date',
        'Double',
        'Timestamp',
        'Boolean',
        'Array',
        'Array Of Strings',
        'Object',
        'ObjectId'
    ];
    importData: boolean;
    scope = [{ 'displayName': 'Public', 'value': 'public' },
    { 'displayName': 'Private', 'value': 'private' }];
    collectionTypes = [{ 'displayName': 'Create New Collection', 'value': 'new' }, {
        'displayName': 'Use Existing Collection',
        'value': 'existing'
    }
    ];
    collectionTypeSelected = 'new';
    scopeSelected = 'public';
    account = new FormControl();
    accounts = ['default'];
    partner = localStorage.getItem('partner');
    partnerKey = localStorage.getItem('partnerKey');
    account_id = localStorage.getItem('account');
    gatewayUrl: any;
    gatewayFullUrl: string;
    // = (this.partner === this.account ? 'https://gateway.' + this.partner + '.apiplatform.io' : 'https://gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
    apiKey = localStorage.getItem('apikey');
    showNextPanel = false;
    angular: any;
    accept = false;

    // entities: any;
    // entityTypes = [];
    enableBlockly = false;
    jwtOrig: any;
    ipRestriction: any;
    isSpecialCharacterInAttribute = false;
    dataTypeArray: any;
    // customType = false;
    previousSavedData: any;
    isValidTableName = false;
    partnerEntities: any;
    partnerExecutors: any;
    isAPIDefinitionImportedFromExistingTable = false;
    isUseExistingTable = false;
    logVisible = false;
    refreshLogCount = 0;
    logTimeStamp: any;
    logComponentRefresh = false;
    apiDeploymentLogs = [];
    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild('myTable') tableNameField: ElementRef;

    options1 = new JsonEditorOptions();
    JSONdata = [{
        'apiAccessPolicy': 'string',
        'attributeName': 'string',
        'type': null,
        'size': null,
        'precision': null,
        'autoIncrement': false,
        'defaultValue': null,
        'attributeType': 'string',
        'dataStoragePolicy': 'string',
        'description': 'string',
        'displayName': 'string',
        'displayPolicy': 'string',
        'required': false,
        'subType': [],
        'compliances': []

    }];
    autoIncrement = [];
    yamlData: any;
    hideBreadcrumb = false;
    route: any;
    enableMonacoEditor = false;

    entity: any;
    origEntity: any;
    origVersion: any;
    items: any;
    origCollection: any;
    content: boolean;
    cloneEnable: boolean;
    contentLoading = true;
    cloneable = false;
    fromHistory = false;
    cloneWithData = false;
    isAPIAlreadyPresent: boolean;
    componentLoading = true;
    isAPIAlreadyPresentCheckCompleted = false;
    previouslyCheckedName: any;
    previouslyCheckedVersion: any;
    isCheckForExistingTable = true;
    isCheckForExistingTableCompleted = false;
    invokingCheckForExistingTableFromDeploy = false;
    previousTableName: string;
    previousSelectedDatatypeFilter: string;
    settingsData: any;
    APIGateways: any;
    selectedAPIGateway: any;
    selectedAPIGatewayName: any;
    operations: any;
    currentMessage: any;
    apiType = 'DATAACCESS';
    connection: any;
    action: any;
    // public createDaasTour: GuidedTour = {
    //     tourId: 'data-access-service-creator',
    //     useOrb: false,
    //     steps: [
    //         {
    //             title: 'Create Data Access Service',
    //             content: 'Get started with creating Data Access Service for a schema and respective APIs such as GET, PUT, POST, PATCH and DELETE in a click',
    //         },
    //         {
    //             title: 'API Name',
    //             selector: '.tour-create-daas-api-name',
    //             content: 'Name of Data Access Service being created.<br> Recommended Naming Conventions: In order to provide consistent developer experience across many APIs and over a long period of time, all names used by an API should be: 1.simple 2.intuitive 3. consistent.',
    //             orientation: Orientation.Right
    //         },
    //         {
    //             title: 'API Version',
    //             selector: '.tour-create-daas-version',
    //             content: 'Version of Data Access Service. ',
    //             orientation: Orientation.Right
    //         },
    //         {
    //             title: 'API Category',
    //             selector: '.tour-create-daas-category',
    //             content: 'Category of Data Access Service. <br> Category is the logical group of APIs to better organize the display of APIs in dashboard. It is recommended to enter a meaningful category of the API for improved searchability.',
    //             orientation: Orientation.Right
    //         }
    //     ]
    // };

    showDialogOnNonWebsocketConnection: any;

    dataTypesDescriptions = [
        {
            database_type: "mongodb",
            dataTypes: [
                {
                    dataType: "ObjectId",
                    description: "Whenever we create a new document in the collection MongoDB automatically creates a unique object id for that document (if the document does not have it). There is an _id field in MongoDB for each document. The data which is stored in Id is of hexadecimal format and the length of the id is 12 bytes which consist: 4-bytes for Timestamp value,  5-bytes for Random values i.e., 3-bytes for machine Id and 2-bytes for process Id, 3- bytes for Counter "
                },
                {
                    dataType: "integer",
                    description: "In MongoDB, the integer data type is used to store an integer value. We can store integer data type in two forms 32 -bit signed integer and 64 – bit signed integer."
                },
                {
                    dataType: "date",
                    description: "Date data type stores date. It is a 64-bit integer which represents the number of milliseconds. BSON data type generally supports UTC datetime and it is signed. If the value of the date data type is negative then it represents the dates before 1970. There are various methods to return a date, it can be returned either as a string or as a date object. Some methods for the date: Date(): It returns the current date in string format, new Date(): Returns a date object. Uses the ISODate() wrapper and new ISODate(): It also returns a date object. Uses the ISODate() wrapper. "
                },
                {
                    dataType: "timestamp",
                    description: "In MongoDB, this data type is used to store a timestamp. It is useful when we modify our data to keep a record and the value of this data type is 64-bit. The value of the timestamp data type is always unique."
                },
                {
                    dataType: "boolean",
                    description: "The Boolean data type is used to store either true or false."
                },
                {
                    dataType: "string",
                    description: "This is the most commonly used data type in MongoDB to store data, BSON strings are of UTF-8. So, the drivers for each programming language convert from the string format of the language to UTF-8 while serializing and de-serializing BSON. The string must be a valid UTF-8. Note: BSON - is the binary encoded format of JSON. "
                },
                {
                    dataType: "object",
                    description: "Object data type stores embedded documents. Embedded documents are also known as nested documents. Embedded document or nested documents are those types of documents which contain a document inside another document. "
                },
                {
                    dataType: "double",
                    description: "The double data type is used to store the floating-point values."
                },
            ]
        },
        {
            database_type: "mysql",
            dataTypes: [
                {
                    dataType: "mediumtext",
                    description: "Holds a string with a maximum length of 16,777,215 characters."
                },
                {
                    dataType: "date",
                    description: "A date. Format: YYYY-MM-DD. The supported range is from '1000-01-01' to '9999-12-31'. "
                },
                {
                    dataType: "bool",
                    description: "Zero is considered as false, nonzero values are considered as true."
                },
                {
                    dataType: "year",
                    description: "A year in four-digit format. Values allowed in four-digit format: 1901 to 2155, and 0000. MySQL 8.0 does not support year in two-digit format."
                },
                {
                    dataType: "tinyblob",
                    description: "For BLOBs (Binary Large Objects). Max length: 255 bytes."
                },
                {
                    dataType: "tinytext",
                    description: "Holds a string with a maximum length of 255 characters."
                },
                {
                    dataType: "mediumblob",
                    description: "For BLOBs (Binary Large Objects). Holds up to 16,777,215 bytes of data. "
                },
                {
                    dataType: "float",
                    description: "A floating point number. The total number of digits is specified in size. The number of digits after the decimal point is specified in the d parameter. This syntax is deprecated in MySQL 8.0.17, and it will be removed in future MySQL versions."
                },
                {
                    dataType: "char",
                    description: "A FIXED length string (can contain letters, numbers, and special characters). The size parameter specifies the column length in characters - can be from 0 to 255. Default is 1. "
                },
                {
                    dataType: "text",
                    description: "Holds a string with a maximum length of 65,535 bytes."
                },
                {
                    dataType: "set",
                    description: "A string object that can have 0 or more values, chosen from a list of possible values. You can list up to 64 values in a SET list."
                },
                {
                    dataType: "longtext",
                    description: "Holds a string with a maximum length of 4,294,967,295 characters. "
                },
                {
                    dataType: "time",
                    description: "A time. Format: hh:mm:ss. The supported range is from '-838:59:59' to '838:59:59'."
                },
                {
                    dataType: "varbinary",
                    description: "Equal to VARCHAR(), but stores binary byte strings. The size parameter specifies the maximum column length in bytes."
                },
                {
                    dataType: "timestamp",
                    description: "A timestamp. TIMESTAMP values are stored as the number of seconds since the Unix epoch ('1970-01-01 00:00:00' UTC). Format: YYYY-MM-DD hh:mm:ss. The supported range is from '1970-01-01 00:00:01' UTC to '2038-01-09 03:14:07' UTC. Automatic initialization and updating to the current date and time can be specified using DEFAULT CURRENT_TIMESTAMP and ON UPDATE CURRENT_TIMESTAMP in the column definition. "
                },
                {
                    dataType: "tinyint",
                    description: "A very small integer. Signed range is from -128 to 127. Unsigned range is from 0 to 255. The size parameter specifies the maximum display width (which is 255). "
                },
                {
                    dataType: "bigint",
                    description: "A large integer. Signed range is from -9223372036854775808 to 9223372036854775807. Unsigned ranges from 0 to 18446744073709551615. The size parameter specifies the maximum display width (which is 255). "
                },
                {
                    dataType: "double",
                    description: "A normal-size floating point number. The total number of digits is specified in size. The number of digits after the decimal point is specified in the d parameter. "
                },
                {
                    dataType: "longblob",
                    description: "For BLOBs (Binary Large Objects). Holds up to 4,294,967,295 bytes of data. "
                },
                {
                    dataType: "mediumint",
                    description: "A medium integer. Signed range is from -8388608 to 8388607. Unsigned range is from 0 to 16777215. The size parameter specifies the maximum display width (which is 255). "
                },
                {
                    dataType: "bit",
                    description: "A bit-value type. The number of bits per value is specified in size. The size parameter can hold a value from 1 to 64. The default value for size is 1. "
                },
                {
                    dataType: "int",
                    description: "A medium integer. Signed range is from -2147483648 to 2147483647. Unsigned range is from 0 to 4294967295. The size parameter specifies the maximum display width (which is 255). "
                },
                {
                    dataType: "blob",
                    description: "For BLOBs (Binary Large Objects). Holds up to 65,535 bytes of data. "
                },
                {
                    dataType: "integer",
                    description: "Equal to INT."
                },
                {
                    dataType: "smallint",
                    description: "A small integer. Signed range is from -32768 to 32767. Unsigned range is from 0 to 65535. The size parameter specifies the maximum display width (which is 255)."
                },
                {
                    dataType: "datetime",
                    description: "A date and time combination. Format: YYYY-MM-DD hh:mm:ss. The supported range is from '1000-01-01 00:00:00' to '9999-12-31 23:59:59'. Adding DEFAULT and ON UPDATE in the column definition to get automatic initialization and updating to the current date and time."
                },
                {
                    dataType: "boolean",
                    description: "Equal to BOOL."
                },
                {
                    dataType: "decimal",
                    description: "An exact fixed-point number. The total number of digits is specified in size. The number of digits after the decimal point is specified in the d parameter. The maximum number for size is 65. The maximum number for d is 30. The default value for size is 10. The default value for d is 0."
                },
                {
                    dataType: "dec",
                    description: "Equal to DECIMAL."
                },
                {
                    dataType: "varchar",
                    description: "A VARIABLE length string (can contain letters, numbers, and special characters). The size parameter specifies the maximum column length in characters - can be from 0 to 65535."
                },
                {
                    dataType: "binary",
                    description: "Equal to CHAR(), but stores binary byte strings. The size parameter specifies the column length in bytes. Default is 1."
                },
                {
                    dataType: "enum",
                    description: "A string object that can have only one value, chosen from a list of possible values. You can list up to 65535 values in an ENUM list. If a value is inserted that is not in the list, a blank value will be inserted. The values are sorted in the order you enter them"
                }
            ]
        },
        {
            database_type: "aurora-mysql",
            dataTypes: [
                {
                    dataType: "char",
                    description: "A FIXED length string (can contain letters, numbers, and special characters). The size parameter specifies the column length in characters - can be from 1 to 104,857,600 characters. Default is 1."
                },
                {
                    dataType: "varchar",
                    description: "A VARIABLE length string (can contain letters, numbers, and special characters). The size parameter specifies the maximum column length in characters - can be from 1 to 104,857,600 characters."
                },
                {
                    dataType: "binary",
                    description: "Equal to CHAR(), but stores binary byte strings. The size parameter specifies the column length in bytes. Range is from 1 to 104,857,600 bytes. Default is 1. "
                },
                {
                    dataType: "varbinary",
                    description: "similar to the VARCHAR type, but stores binary byte strings rather than non-binary character strings. Can be from 1 to 104,857,600 bytes."
                },
                {
                    dataType: "tinyblob",
                    description: "For BLOBs (Binary Large Objects). Max length: 104,857,600"
                },
                {
                    dataType: "tinytext",
                    description: "Holds a string with length of 1 to 104,857,600 characters. "
                },
                {
                    dataType: "text",
                    description: "Holds a string with a maximum length of 104,857,600 characters."
                },
                {
                    dataType: "blob",
                    description: "For BLOBs (Binary Large Objects). Holds up to 1 to 104,857,600 bytes of data."
                },
                {
                    dataType: "mediumtext",
                    description: "Holds a string with a maximum length of 104,857,600 characters. "
                },
                {
                    dataType: "mediumblob",
                    description: "For BLOBs (Binary Large Objects). Holds 1 to 104,857,600 bytes of data. "
                },
                {
                    dataType: "longtext",
                    description: "Holds a string with a maximum length of 104,857,600 characters. "
                },
                {
                    dataType: "enum",
                    description: "A string object that can have only one value, chosen from a list of possible values. You can list up to 65535 values in an ENUM list. If a value is inserted that is not in the list, a blank value will be inserted. The values are sorted in the order you enter them. Ranges from 1 to 104,857,600 characters."
                },
                {
                    dataType: "set",
                    description: "A string object that can have 0 or more values, chosen from a list of possible values. You can list up to 104,857,600 characters in a SET list"
                },
                {
                    dataType: "bit",
                    description: "A bit-value type. The number of bits per value is specified in size. The size parameter can hold a value from -2,147,483,648 to 2,147,483,647. The default value for size is 1."
                },
                {
                    dataType: "tinyint",
                    description: "A very small integer. Signed range is from -2,147,483,648 to 2,147,483,647. Unsigned range is from 0 to 255. The size parameter specifies the maximum display width (which is 255)."
                },
                {
                    dataType: "bool",
                    description: "Zero is considered as false, nonzero values are considered as true."
                },
                {
                    dataType: "boolean",
                    description: "Equal to BOOL."
                },
                {
                    dataType: "smallint",
                    description: "A small integer. Signed range is from -2,147,483,648 to 2,147,483,647. Unsigned range is from 0 to 65535. The size parameter specifies the maximum display width (which is 255)."
                },
                {
                    dataType: "mediumint",
                    description: "A medium integer.  The size parameter specifies the maximum display width."
                },
                {
                    dataType: "int",
                    description: "A medium integer. Signed range is from -2147483648 to 2147483647. Unsigned range is from 0 to 4294967295. The size parameter specifies the maximum display width."
                },
                {
                    dataType: "integer",
                    description: "Equal to INT."
                },
                {
                    dataType: "float",
                    description: "A floating point number. The total number of digits is specified in size. The number of digits after the decimal point is specified in the d parameter. "
                },
                {
                    dataType: "double",
                    description: "A normal-size floating point number. The total number of digits is specified in size. The number of digits after the decimal point is specified in the d parameter."
                },
                {
                    dataType: "decimal",
                    description: "An exact fixed-point number. The total number of digits is specified in size. The number of digits after the decimal point is specified in the d parameter. The maximum number for size is 65. The maximum number for d is 30. The default value for size is 10. The default value for d is 0."
                },
                {
                    dataType: "dec",
                    description: "Equal to DECIMAL."
                },
                {
                    dataType: "date",
                    description: "A date. Format: YYYY-MM-DD. The supported range is from '1000-01-01' to '9999-12-31'. Range is from Jan 1, 0001 A.D. to Dec 31, 9999 A.D."
                },
                {
                    dataType: "datetime",
                    description: "A date and time combination. Format: YYYY-MM-DD hh:mm:ss. The supported range is from '1000-01-01 00:00:00' to '9999-12-31 23:59:59'. Adding DEFAULT and ON UPDATE in the column definition to get automatic initialization and updating to the current date and time. Range is from Jan 1, 0001 A.D. to Dec 31, 9999 A.D."
                },
                {
                    dataType: "time",
                    description: "A time. Format: hh:mm:ss. The supported range is from '-838:59:59' to '838:59:59'. Range is from Jan 1, 0001 A.D. to Dec 31, 9999 A.D."
                },
                {
                    dataType: "year",
                    description: "A year in four-digit format. Values allowed in four-digit format: 1901 to 2155, and 0000. Range os from 1 to 104,857,600 characters."
                },
                {
                    dataType: "bigint",
                    description: "A large integer. Signed range is from -9223372036854775808 to 9223372036854775807. Unsigned ranges from 0 to 18446744073709551615. The size parameter specifies the maximum display width (which is 255)."
                },
                {
                    dataType: "longblob",
                    description: "For BLOBs (Binary Large Objects). Holds up to 4,294,967,295 bytes of data. "
                },
                {
                    dataType: "timestamp",
                    description: "A timestamp. TIMESTAMP values are stored as the number of seconds since the Unix epoch ('1970-01-01 00:00:00' UTC). Format: YYYY-MM-DD hh:mm:ss. The supported range is from '1970-01-01 00:00:01' UTC to '2038-01-09 03:14:07' UTC. Automatic initialization and updating to the current date and time can be specified using DEFAULT CURRENT_TIMESTAMP and ON UPDATE CURRENT_TIMESTAMP in the column definition. "
                },
            ]
        },
        {
            database_type: "sqlserver",
            dataTypes: [
                {
                    dataType: "money",
                    description: "Monetary data from -922,337,203,685,477.5808 to 922,337,203,685,477.5807. Size is 8 bytes."
                },
                {
                    dataType: "bit",
                    description: "Integer that can be 0, 1, or NULL."
                },
                {
                    dataType: "numeric",
                    description: "Fixed precision and scale numbers. Allows numbers from -10^38 +1 to 10^38 –1. The p parameter indicates the maximum total number of digits that can be stored (both to the left and to the right of the decimal point). p must be a value from 1 to 38. Default is 18. The s parameter indicates the maximum number of digits stored to the right of the decimal point. s must be a value from 0 to p. Default value is 0."
                },
                {
                    dataType: "decimal",
                    description: "Fixed precision and scale numbers. Allows numbers from -10^38 +1 to 10^38 –1. The p parameter indicates the maximum total number of digits that can be stored (both to the left and to the right of the decimal point). p must be a value from 1 to 38. Default is 18. The s parameter indicates the maximum number of digits stored to the right of the decimal point. s must be a value from 0 to p. Default value is 0."
                },
                {
                    dataType: "float",
                    description: "Floating precision number data from -1.79e + 308 to 1.79e + 308. The n parameter indicates whether the field should hold 4 or 8 bytes. Float(24) holds a 4-byte field and float(53) holds an 8-byte field. Default value of n is 53."
                },
                {
                    dataType: "image",
                    description: "Variable width binary string. Max size 2GB."
                },
                {
                    dataType: "nchar",
                    description: "Fixed width unicode string. Max size 4,000 characters."
                },
                {
                    dataType: "ntext",
                    description: "Variable width unicode string. Max size 2gb of text data."
                },
                {
                    dataType: "int",
                    description: "Allows whole numbers between -2,147,483,648 and 2,147,483,647. Storage - 4 bytes. "
                },
                {
                    dataType: "varchar",
                    description: "Variable width character string. Max size 8,000 characters."
                },
                {
                    dataType: "binary",
                    description: "Fixed width binary string. Max size 8,000 bytes."
                },
                {
                    dataType: "smallint",
                    description: "Allows whole numbers between -32,768 and 32,767. Storage 2 bytes."
                },
                {
                    dataType: "smallmoney",
                    description: "Monetary data from -214,748.3648 to 214,748.3647. Storage 4 bytes."
                },
                {
                    dataType: "nvarchar",
                    description: "variable width unicode string. Max size 4,000 characters."
                },
                {
                    dataType: "text",
                    description: "Variable width character string. Max size 2gb of text data. Storage 4 bytes + number of chars."
                },
                {
                    dataType: "char",
                    description: "Fixed width character string. Max size 8,000 characters."
                },
                {
                    dataType: "varbinary",
                    description: "Variable width binary string. Max size 8,000 bytes."
                },
                {
                    dataType: "tinyint",
                    description: "Allows whole numbers from 0 to 255. Storage 1 byte."
                },
                {
                    dataType: "datetime",
                    description: "From January 1, 1753 to December 31, 9999 with an accuracy of 3.33 milliseconds. Storage 8 bytes."
                },
                {
                    dataType: "date",
                    description: "Store a date only. From January 1, 0001 to December 31, 9999. Storage 3 bytes. "
                },
                {
                    dataType: "uniqueidentifier",
                    description: "Stores a globally unique identifier (GUID)."
                },
                {
                    dataType: "bigint",
                    description: "Allows whole numbers between -9,223,372,036,854,775,808 and 9,223,372,036,854,775,807. Storage 8 bytes."
                },
                {
                    dataType: "datetime2",
                    description: "From January 1, 0001 to December 31, 9999 with an accuracy of 100 nanoseconds. Storage 6-8 bytes."
                },
            ]
        },
        {
            database_type: "postgresql",
            dataTypes: [
                {
                    dataType: "char",
                    description: "From January 1, 0001 to December 31, 9999 with an accuracy of 100 nanoseconds. Storage 6-8 bytes."
                },
                {
                    dataType: "text",
                    description: "Variable-length character string."
                },
                {
                    dataType: "varchar",
                    description: "Variable-length character string."
                },
                {
                    dataType: "smallint",
                    description: "Signed two-byte integer."
                },
                {
                    dataType: "integer",
                    description: "Signed four-byte integer."
                },
                {
                    dataType: "bigint",
                    description: "Signed eight-byte integer."
                },
                {
                    dataType: "serial",
                    description: "Autoincrementing four-byte integer."
                },
                {
                    dataType: "real",
                    description: "Single precision floating-point number (4 bytes)."
                },
                {
                    dataType: "numeric",
                    description: "Exact numeric of selectable precision."
                },
                {
                    dataType: "date",
                    description: "Calendar date (year, month, day)."
                },
                {
                    dataType: "time",
                    description: "Time of day."
                },
                {
                    dataType: "timestamp",
                    description: "Date and time (no time zone)."
                },
                {
                    dataType: "timestampz",
                    description: "Date and time, including time zone."
                },
                {
                    dataType: "interval",
                    description: "Time span."
                },
                {
                    dataType: "arrays",
                    description: "PostgreSQL allows columns of a table to be defined as variable-length multidimensional arrays. Arrays of any built-in or user-defined base type, enum type, composite type, range type, or domain can be created. "
                },
                {
                    dataType: "json",
                    description: "Textual Json data."
                },
                {
                    dataType: "jsonb",
                    description: "Binary Json data, decomposed."
                },
                {
                    dataType: "uuid",
                    description: "Universally unique identifier."
                },
                {
                    dataType: "box",
                    description: "Rectangular box on a plane."
                },
                {
                    dataType: "line",
                    description: "Infinite line on a plane."
                },
                {
                    dataType: "point",
                    description: "Geometric point on a plane."
                },
                {
                    dataType: "lseg",
                    description: "Line segment on a plane."
                },
                {
                    dataType: "polygon",
                    description: "Closed geometric path on a plane."
                },
                {
                    dataType: "inet",
                    description: "IPv4 or IPv6 host address."
                },
                {
                    dataType: "macaddr",
                    description: "MAC (media access control) address."
                },
                {
                    dataType: "timestamptz",
                    description: "Date and time, including time zone."
                },
                {
                    dataType: "bool",
                    description: "Logical Boolean (true/false)."
                },
                {
                    dataType: "int2",
                    description: "Signed two-byte integer."
                },
                {
                    dataType: "int4",
                    description: "Signed four-byte integer."
                },
                {
                    dataType: "int8",
                    description: "Signed eight-byte integer."
                },
                {
                    dataType: "float",
                    description: "float is used for floating-point numbers with n precision and can have a maximum of 8-bytes."
                },
                {
                    dataType: "array",
                    description: "In PostgreSQL, an array column can be used to store an array of strings or an array of integers etc. It can be handy when storing data likes storing days of months, a year, or even a week, etc."
                },
            ]
        },
        {
            database_type: "dynamodb",
            dataTypes: [
                {
                    dataType: "set(number)",
                    description: "DynamoDB supports types that represent sets of number, string, or binary values. All the elements within a set must be of the same type. An attribute of type number set can only contain numbers. There is no limit on the number of values in a set, as long as the item containing the values fits within the DynamoDB item size limit (400 KB). Each value within a set must be unique. The order of the values within a set is not preserved."
                },
                {
                    dataType: "list",
                    description: "A list type attribute can store an ordered collection of values. Lists are enclosed in square brackets: [ ... ] . A list is similar to a Json array. There are no restrictions on the data types that can be stored in a list element, and the elements in a list element do not have to be of the same type."
                },
                {
                    dataType: "boolean",
                    description: "A Boolean type attribute can store either true or false."
                },
                {
                    dataType: "map",
                    description: "A map type attribute can store an unordered collection of name-value pairs. Maps are enclosed in curly braces: { ... }. A map is similar to a Json object. There are no restrictions on the data types that can be stored in a map element, and the elements in a map do not have to be of the same type. Maps are ideal for storing Json documents in DynamoDB. "
                },
                {
                    dataType: "set(binary)",
                    description: "DynamoDB supports types that represent sets of number, string, or binary values. All the elements within a set must be of the same type. An attribute of type binary set can only contain binary values. There is no limit on the number of values in a set, as long as the item containing the values fits within the DynamoDB item size limit (400 KB). Each value within a set must be unique. The order of the values within a set is not preserved. DynamoDB does not support empty sets, however, empty string and binary values are allowed within a set. "
                },
                {
                    dataType: "number",
                    description: "Numbers can be positive, negative, or zero. Numbers can have up to 38 digits of precision. Exceeding this results in an exception. Positive range: 1E-130 to 9.9999999999999999999999999999999999999E+125. Negative range: -9.9999999999999999999999999999999999999E+125 to -1E-130. In DynamoDB, numbers are represented as variable length. Leading and trailing zeroes are trimmed. All numbers are sent across the network to DynamoDB as strings, to maximize compatibility across languages and libraries. However, DynamoDB treats them as number type attributes for mathematical operations."
                },
                {
                    dataType: "null",
                    description: "Null represents an attribute with an unknown or undefined state."
                },
                {
                    dataType: "string",
                    description: "strings are Unicode with utf-8 binary encoding. The minimum length of a string can be zero, if the attribute is not used as a key for an index or table, and is constrained by the maximum DynamoDB item size limit of 400 kb. The following additional constraints apply to primary key attributes that are defined as type string: For a simple primary key, the maximum length of the first attribute value (the partition key) is 2048 bytes. For a composite primary key, the maximum length of the second attribute value (the sort key) is 1024 bytes. DynamoDB collates and compares strings using the bytes of the underlying utf-8 string encoding. For example, \"a\" (0x61) is greater than \"a\" (0x41), and \"\" (0xc2bf) is greater than \"z\" (0x7a)."
                },
                {
                    dataType: "binary",
                    description: "Binary type attributes can store any binary data, such as compressed text, encrypted data, or images. Whenever dynamodb compares binary values, it treats each byte of the binary data as unsigned. The length of a binary attribute can be zero, if the attribute is not used as a key for an index or table, and is constrained by the maximum dynamodb item size limit of 400 kb. If you define a primary key attribute as a binary type attribute, the following additional constraints apply: For a simple primary key, the maximum length of the first attribute value (the partition key) is 2048 bytes. For a composite primary key, the maximum length of the second attribute value (the sort key) is 1024 bytes."
                },
                {
                    dataType: "set(string)",
                    description: "DynamoDB supports types that represent sets of number, string, or binary values. All the elements within a set must be of the same type. String Set can only contain strings. There is no limit on the number of values in a set, as long as the item containing the values fits within the DynamoDB item size limit (400 KB). Each value within a set must be unique. The order of the values within a set is not preserved. DynamoDB does not support empty sets, however, empty string and binary values are allowed within a set."
                },
            ]
        },
        {
            database_type: "aurora-postgresql",
            dataTypes: [
                {
                    dataType: "char",
                    description: "From January 1, 0001 to December 31, 9999 with an accuracy of 100 nanoseconds. Storage 6-8 bytes."
                },
                {
                    dataType: "text",
                    description: "Variable-length character string."
                },
                {
                    dataType: "varchar",
                    description: "Variable-length character string."
                },
                {
                    dataType: "smallint",
                    description: "Signed two-byte integer."
                },
                {
                    dataType: "integer",
                    description: "Signed four-byte integer."
                },
                {
                    dataType: "bigint",
                    description: "Signed eight-byte integer."
                },
                {
                    dataType: "serial",
                    description: "Autoincrementing four-byte integer."
                },
                {
                    dataType: "real",
                    description: "Single precision floating-point number (4 bytes)."
                },
                {
                    dataType: "numeric",
                    description: "Exact numeric of selectable precision."
                },
                {
                    dataType: "date",
                    description: "Calendar date (year, month, day)."
                },
                {
                    dataType: "time",
                    description: "Time of day."
                },
                {
                    dataType: "timestamp",
                    description: "Date and time (no time zone)."
                },
                {
                    dataType: "timestampz",
                    description: "Date and time, including time zone."
                },
                {
                    dataType: "interval",
                    description: "Time span."
                },
                {
                    dataType: "arrays",
                    description: "PostgreSQL allows columns of a table to be defined as variable-length multidimensional arrays. Arrays of any built-in or user-defined base type, enum type, composite type, range type, or domain can be created. "
                },
                {
                    dataType: "json",
                    description: "Textual Json data."
                },
                {
                    dataType: "jsonb",
                    description: "Binary Json data, decomposed."
                },
                {
                    dataType: "uuid",
                    description: "Universally unique identifier."
                },
                {
                    dataType: "box",
                    description: "Rectangular box on a plane."
                },
                {
                    dataType: "line",
                    description: "Infinite line on a plane."
                },
                {
                    dataType: "point",
                    description: "Geometric point on a plane."
                },
                {
                    dataType: "lseg",
                    description: "Line segment on a plane."
                },
                {
                    dataType: "polygon",
                    description: "Closed geometric path on a plane."
                },
                {
                    dataType: "inet",
                    description: "IPv4 or IPv6 host address."
                },
                {
                    dataType: "macaddr",
                    description: "MAC (media access control) address."
                },
                {
                    dataType: "timestamptz",
                    description: "Date and time, including time zone."
                },
                {
                    dataType: "bool",
                    description: "Logical Boolean (true/false)."
                },
                {
                    dataType: "int2",
                    description: "Signed two-byte integer."
                },
                {
                    dataType: "int4",
                    description: "Signed four-byte integer."
                },
                {
                    dataType: "int8",
                    description: "Signed eight-byte integer."
                },
            ]
        },
        {
            database_type: "cosmosdb",
            dataTypes: [
                {
                    dataType: "string",
                    description: "You can specify string data type with characters. Its size ranges from 1 to 104,857,600 characters."
                },
                {
                    dataType: "integer",
                    description: "The integer data type is used to store an integer value. Its size ranges from -2,147,483,648 to 2,147,483,647."
                },
                {
                    dataType: "double",
                    description: "The double data type is also used to store the floating-point values. Its size ranges from -1.79769313486231570E+308 to +1.79769313486231570E+308. "
                },
                {
                    dataType: "float",
                    description: "The default transformation type for float is double. The float data type is used to store the floating-point values. Its size ranges from -1.79769313486231570E+308 to +1.79769313486231570E+308."
                },
                {
                    dataType: "boolean",
                    description: "The default transformation type for Boolean is integer. You can specify string data type with values of True and False. True is equivalent to the integer 1 and False is equivalent to the integer 0."
                },
            ]
        }
    ];

    constructor(private confPost: ConfService,
        private kongService: KongService,
        public dialog: MatDialog,
        private _service: ConnecttocrudService,
        private router: Router,
        private location: Location,
        private _route: ActivatedRoute,
        private appComp: AppComponent,
        private websocketService: WebsocketService,
        private apiCreatorService: ApiCreatorsService,
        public accountInfoService: AccountInfoService, private auditLog: AuditLogService,
        private leftPanelDataListener: ListenerService, public platform: LeftpanelComponent, private dataAccessListenerInstance: DataaccessListenerService,
        private auditListenerService: AuditListenerService,
        private ngxXml2jsonService: NgxXml2jsonService, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {

        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log(/* this.editor.get()*/);
        iconRegistry.addSvgIcon(
            'video',
            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/video.svg'));

        this.apiCreatorService.eventCallback$.subscribe(value => {

            if (value.apiName === this.entityName && value.apiVersion === this.version) {
                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
                if (!this.websocketService.isOpen()) {
                    // if (value.result === 'failure') {
                    //     this.displaySnackBarWithWS('Error', 5000, value.message);
                    // } else if (value.result === 'success') {
                    //     this.Blocks = [1, 2, 4, 5];
                    //     const blockLength = this.Blocks.length;
                    //     const blockStart = this.BlockList[this.Blocks[0]];
                    //     const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    //     this.progress = blockStart;
                    //     // this.leftPanelDataListener.changeInLeftPanelDataV2.emit('sql');
                    //
                    //     this.setInterval(blockEnd, true);
                    // }
                    this.logVisible = true;
                    this.refreshLogCount++;
                }
                if (value.result === 'failure') {
                    const errorCode = value.auditPayload ? value.auditPayload.statusCode ? value.auditPayload.statusCode : 400 : 400;
                    const errorMessage = value.auditPayload ? value.auditPayload.message ? value.auditPayload.message : '' : '';
                    Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.dass, 'API_DEPLOY', 'DEPLOY', 'FAIL', '', errorCode, '', '', errorMessage)).then(response => {
                        this.auditListenerService.auditListener.emit({
                            type: 'auditLog',
                            category: 'isAuditForDataAccess',
                            payload: response
                        });
                    });
                } else if (value.result === 'success') {
                    const statusCode = value.auditPayload ? value.auditPayload.statusCode ? value.auditPayload.statusCode : 201 : 201;
                    const message = value.auditPayload ? value.auditPayload.message ? value.auditPayload.message : 'API created' : 'API created';
                    Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, this.platform.auditLabels.api_create, this.platform.auditFeatureArea.dass, 'API_DEPLOY', 'DEPLOY', 'SUCCESS', '', statusCode, '', '', message)).then(response => {
                        this.auditListenerService.auditListener.emit({
                            type: 'auditLog',
                            category: 'isAuditForDataAccess',
                            payload: response
                        });
                    });
                }
            }
        });
    }

    displaySnackBarWithWS(type, duration, msg) {
        if (!this.websocketService.isOpen()) {
            this.platform.openSnackBar(msg, type, {
                duration: duration,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }


    addnewrow(val) {
        this.addAttributeField(this.apiByDefinition, this.selectDatabase);
    }

    Change() {
        this.ispublished = !this.ispublished;
    }

    addAttributeField(data, database) {
        this.autoIncrement.push(false);
        if (database === 'mongodb' || database === 'default') {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'array': false,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': [],
                'compliances': []
            };
            data.push(newField);
        } else {
            const newField = {
                'customType': false,
                'apiAccessPolicy': 'None',
                'attributeName': null,
                'type': null,
                'size': null,
                'precision': null,
                'autoIncrement': false,
                'defaultValue': null,
                'attributeType': 'None',
                'dataStoragePolicy': 'None',
                'description': null,
                'displayName': null,
                'displayPolicy': null,
                'required': false,
                'subType': [],
                'compliances': []
            };
            data.push(newField);
        }
    }

    omit_special_char(event) {

        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57));
        return (k !== 95);
    }

    checkNumber(event) {
        let k;
        k = event.charCode;
        return ((k >= 48 && k <= 57));
    }

    checkDefault(event, val) {
        if (val === true) {
            let k;
            k = event.charCode;
            return ((k >= 48 && k <= 57));
        }
    }

    typeCheck(definition, type, index) {
        for (let i = 0; i < this.dataTypeFilter.length; i++) {
            if (this.dataTypeFilter[i]['data_types'][0]['type'] === type) {
                if (this.dataTypeFilter[i]['data_types'][0]['family'] === 'Number') {
                    this.autoIncrement[index] = true;
                } else {
                    this.apiByDefinition[index]['autoIncrement'] = false;
                    this.autoIncrement[index] = false;
                }
            }
        }
        const entityAndVersionCheckString = definition.type,
            substring = '_';
        if (entityAndVersionCheckString.includes(substring)) {
            definition.customType = true;
            definition.attributeType = 'DBRef';
            definition.array = true;
        } else {
            definition.customType = false;
            if (definition.attributeType === 'Primary') {
                this.flagValue = true;
                definition.autoIncrement = false;
                definition.required = false;
            }
            definition.attributeType = 'None';
            definition.array = false;
        }

        if (this.selectDatabase === 'default' || this.selectDatabase === 'mongo') {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition.subType, this.selectDatabase);
            } else {
                this.removeAttributeField(definition.subType);
            }
        } else {
            if (definition.type === 'Array' || definition.type === 'Object') {
                this.addAttributeField(definition.subType, this.selectDatabase);
            } else {
                this.removeAttributeField(definition.subType);
            }
        }
    }

    removeAttributeField(data) {
        for (var i = 0; i < data.length; i++) {
            data.splice(i, 1);
        }
    }

    removeAttribute(data, index, type) {
        if (confirm('Are you sure you want to remove this attribute?')) {
            if (type === 'Primary') {
                this.flagValue = true;
            }
            this.autoIncrement.splice(index, 1);
            data.splice(index, 1);
            // alert('Attribute removed');
        }
    }

    setPrimaryFlag(i, type) {
        if (type === 'Primary' && this.flagValue) {
            this.flag = i;
            this.flagValue = false;
        } else if (i === this.flag && !this.flagValue && type !== 'Primary') {
            this.flag = null;
            this.flagValue = true;
            this.apiByDefinition[i]['autoIncrement'] = false;
        }
        if (type === 'Primary') {
            this.apiByDefinition[i]['required'] = true;
        } else {
            this.apiByDefinition[i]['required'] = false;
        }
    }

    onInit(editor) {
        let line = editor.getPosition();

    }

    enableMonaco(ev) {
        if (ev.tab.textLabel.trim() === 'Open API') {
            this.enableMonacoEditor = true;
        }
        if (ev.tab.textLabel.trim() === 'Business Logic') {
            this.enableBlockly = true;
        } else {
            //  this.enableMonacoEditor = false;
        }

    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        if (this.platform.settingsData !== null && this.platform.settingsData !== undefined && this.platform.settingsData !== '') {
            this.settingsData = this.platform.settingsData;
            this.getDefaultGatewaySettings(this.settingsData);
        } else {
            this.confPost.getSettingsV2CRUD(localStorage.getItem('partner'), localStorage.getItem('account'), false).subscribe(settingsData => {
                if (settingsData['body'] && settingsData['body'][0]) {
                    this.settingsData = settingsData;
                    this.getDefaultGatewaySettings(this.settingsData);
                }
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving settings data. Please try again after sometime.');
            });
        }

        this.appComp.currentPageTitle = 'Create Data Access API';
        this.gatewayUrl = await this.platform.getDefaultGatewayURL();
        this.gatewayFullUrl = 'https://' + this.gatewayUrl;
        this.router.events.subscribe(event => {
            this.route = this.location.path();
            if (this.route.includes('/swifter')) {
                this.hideBreadcrumb = true;
            } else {
                this.hideBreadcrumb = false;
            }
        });

        if (this.location.path() !== '') {
            this.route = this.location.path();
            if (this.route.includes('/swifter')) {
                this.hideBreadcrumb = true;
            } else {
                this.hideBreadcrumb = false;
            }
        }

        if (this.platform.apiGateways !== null && this.platform.apiGateways !== undefined) {
            this.apiGateways = this.platform.apiGateways;
        } else {
            await this.confPost.getPartnerSettings(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey')).toPromise().then(data => {
                let resp: any;
                resp = data;
                this.apiGateways = resp['apigateway'];
                this.platform.apiGateways = resp['apigateway'];
            },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of API Gateways. Please try again after sometime.');
                });
        }

        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
        } else {
            await this.confPost.getDataTypes().toPromise().then(data => {

                    this.datatypes = data;
                    this.platform.datatypes = data;
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of data types. Please try again after sometime.');
                });
        }
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            await this.platform.updateIsNoSQLForMongo(this.platform.databases);
            this.databases = this.platform.databases;
        } else {
            // this.platform.getDatabasesForPartnerAccount();
            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                await this.platform.updateIsNoSQLForMongo(databases);
                this.databases = this.platform.databases;
            },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                });
            this.databases = this.platform.databases;
        }
        // this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {

        if (this.platform.partnerCategories !== null && this.platform.partnerCategories !== undefined) {
            this.options = this.platform.partnerCategories;
            if (this.options !== null && this.options !== undefined) {
                this.filteredOptions = this.myControl.valueChanges
                    .pipe(
                        startWith<string | ICategory>(''),
                        map(value => typeof value === 'string' ? value : value.name),
                        map(name => name ? this._filter(name) : this.options.slice())
                    );
            }

        } else {
            await this.confPost.getCategoriesForPartner(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
                this.options = data;
                this.platform.partnerCategories = this.options;
                if (this.options !== null && this.options !== undefined) {
                    this.filteredOptions = this.myControl.valueChanges
                        .pipe(
                            startWith<string | ICategory>(''),
                            map(value => typeof value === 'string' ? value : value.name),
                            map(name => name ? this._filter(name) : this.options.slice())
                        );
                }
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while retrieving data access services group by categories for your account. Please try again after sometime.');
            });
        }

        // });

        // if (this.platform.countPartnerAccountEntities !== null && this.platform.countPartnerAccountEntities !== undefined) {
        //     this.countPartnerAccountEntities = this.platform.countPartnerAccountEntities;
        // } else {
        //     this.platform.getEntityCountForPartnerAccount();
        //     this.countPartnerAccountEntities = this.platform.countPartnerAccountEntities;
        // }
        // if (this.platform.countPartnerEntities !== null && this.platform.countPartnerEntities !== undefined) {
        //     this.countPartnerEntities = this.platform.countPartnerEntities;
        // } else {
        //     this.platform.getEntityCountForPartner();
        //     this.countPartnerEntities = this.platform.countPartnerEntities;
        // }

        this._route.queryParams
            .subscribe(async params => {
                this.cloneable = false;
                this.fromHistory = false;
                if (params.clone) {
                    this.cloneable = true;
                    if (params.data === 'true') {
                        this.cloneWithData = true;
                    }
                    if (this.platform.cloneableData) {
                        if (this.platform.cloneableData['database'] !== 'default') {
                            for (let i = 0; i < this.platform.cloneableData['attributes'].length; i++) {
                                this.platform.cloneableData['attributes'][i]['updateOption'] = 'none';
                            }
                        }
                        this.apiByDefinition = this.platform.cloneableData['attributes'];
                        this.entityName = this.platform.cloneableData['entityname'];
                        this.version = this.platform.cloneableData['version'];
                        this.tableName = this.platform.cloneableData['tableName'];
                        this.apiCategory = this.platform.cloneableData['category'];
                        this.displayName = this.platform.cloneableData['displayname'];
                        this.ispublished = this.platform.cloneableData['published'];
                        // this.selectDatabase = this.platform.cloneableData['database'];
                        // this.filterDataTypes(this.selectDatabase);
                        this.description = this.platform.cloneableData['description'];
                        if (this.platform.cloneableData.methods
                            && this.platform.cloneableData.methods !== null
                            && this.platform.cloneableData.methods !== undefined
                            && this.platform.cloneableData.methods.length > 0) {
                            this.methodType = [];
                            this.platform.cloneableData.methods.forEach(method => {
                                this.methodType.push({ 'id': method, 'itemName': method });
                            });
                            // this.methodType = this.items.methods;
                            // this.origMethods = this.items.methods;
                        } else {
                            this.methodType = this.methodTypes;
                        }
                        this.origCollection = this.platform.cloneableData['tableName'];
                        this.content = true;
                        this.ispublished = this.platform.cloneableData['published'];
                        await this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(async data => {
                            await this.platform.updateIsNoSQLForMongo(data);
                            this.databases = this.platform.databases;
                            this.filterDataTypes(this.platform.cloneableData.database);
                        }, error => {
                            this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                        });
                        let isCloneableDBPresent = false;
                        this.databases.forEach((database) => {
                            if (database) {
                                if (database['database_name'] === this.platform.cloneableData.database) {
                                    isCloneableDBPresent = true;
                                }
                            }
                        });
                        if (isCloneableDBPresent === false) {
                            this.databases.push({ 'database_name': this.platform.cloneableData.database, 'database_type': '' });
                        }
                        this.selectDatabase = this.platform.cloneableData.database;
                        this.filterDataTypes(this.platform.cloneableData.database);
                        if (this.partner === 'commons' || this.partner === 'templates') {
                            this.cloneEnable = true;
                        }
                        this.contentLoading = false;
                    } else {
                        this.router.navigateByUrl('/dataaccessapi');
                    }

                } else if (params.timestamp && params.timestamp !== null && params.timestamp !== undefined && params.timestamp !== '') {
                    this.fromHistory = true;
                    this.confPost.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + this.partner + '&account=' + this.account_id + '&at=' + params.timestamp).subscribe(response => {
                        if (response && response !== null && response !== undefined && response[0] && response[0]['executor']) {
                            const executor = response[0]['executor'];
                            this.entityName = executor.entityname;
                            this.apiCategory = executor.category;
                            this.tableName = executor.tableName;
                            this.displayName = executor.displayname;
                            this.description = executor.description;
                            this.ispublished = executor.published;
                            this.scopeSelected = executor.scopeOfAccess;
                            this.selectDatabase = executor.database;
                            this.filterDataTypes(this.selectDatabase);
                            this.version = executor.version;
                            this.apiByDefinition = executor.attributes;
                            if (executor.methods && executor.methods !== null && executor.methods !== undefined && executor.methods.length > 0) {
                                this.methodType = [];
                                executor.methods.forEach(method => {
                                    this.methodType.push({ 'id': method, 'itemName': method });
                                });
                            } else {
                                this.methodType = this.methodTypes;
                            }
                            this.contentLoading = false;
                        } else {
                            this.contentLoading = false;
                            this.platform.openSnackBar('Error in retrieving the history for this API', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    }, error => {
                        this.contentLoading = false;
                        this.platform.handleErrorGracefully(error, 'Error in retrieving the history for this API. Please try again after sometime.');
                    });
                } else {
                    this.contentLoading = false;
                    this.entityName = '';
                    this.apiCategory = '';
                    this.tableName = '';
                    this.displayName = '';
                    this.description = '';
                    this.ispublished = true;
                    this.scopeSelected = 'public';
                    this.selectDatabase = '';
                    this.version = '';
                    this.methodType = [];
                    this.apiByDefinition = [{
                        'customType': false,
                        'apiAccessPolicy': 'None',
                        'attributeName': null,
                        'type': null,
                        'array': false,
                        'size': null,
                        'precision': null,
                        'autoIncrement': false,
                        'defaultValue': null,
                        'attributeType': 'None',
                        'dataStoragePolicy': 'None',
                        'description': null,
                        'displayName': null,
                        'displayPolicy': 'None',
                        'required': false,
                        'subType': [],
                        'compliances': []

                    }];
                }
            });

        $(document).on('click', '.removeHeader', function () {
            $(this).closest('td').parent('tr').remove();
        });


        // setTimeout(() => {
        //     this.platform.guidedTourService.startTour(this.platform.createDaasTour);
        // }, 1000);
    }

    // getEntitiesForPartnerAccount(partner, account) {
    //     this.confPost.getEntitiesForPartnerAccount(partner, account).subscribe(data => {
    //         this.entities = data;
    //         this.entities.forEach(entity => {
    //             this.entityTypes.push(entity.entityname + '_' + entity.version);
    //         });
    //     });
    // }


    delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    listenAPICreation(timestamp, apiName, apiVersion) {
        if (this.websocketService.isOpen()) {
            this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, 'deploy').subscribe(data => {
                if (data) {
                    this.currentMessage = JSON.parse(data.body);
                }
            });
        }
    }

    // async createAPIDuplicate() {
    //     if (this.websocketService.checkConnection()) {
    //         this.connection = true;
    //     } else {
    //         this.connection = false;
    //     }
    //     this.action = 'deploy';
    //     this.entityName = 'sample';
    //     this.version = 'v1';
    //     this.apiType = 'daas';
    //     this.currentMessage = '';
    //     const timestamp = Date.now();
    //     await this.websocketService.checkConnection();
    //     this.listenAPICreation(timestamp, 'sample', 'v1');
    //     this.logVisible = true;
    //     this.logComponentRefresh = true;
    //     this.platform.publishEventMessage('sample', 'v1', 'CREATION', {
    //         info: 'creating api',
    //         icon: 'fa fa-edit',
    //         type: 'inital'
    //     }, timestamp, 'deploy');
    //     await this.delay(2000);
    //     this.platform.publishEventMessage('sample', 'v1', 'CREATION', {
    //         info: 'creating api',
    //         type: 'error',
    //         description: {},
    //         executor_method_type: 'POST',
    //         executor_type: '',
    //         authorization: {},
    //         queryParameters: [],
    //         pathParameters: [],
    //         url: 'https://dev-kassu.gateway.apiplatform.io/v1/pg1',
    //         headers: {
    //             apikey: localStorage.getItem('apikey'),
    //             pkey: localStorage.getItem('partnerKey')
    //         },
    //         request_body: {
    //             name: 'shanthan',
    //             age: 21
    //         },
    //         executor: {},
    //     }, timestamp, 'deploy');
    //     await this.delay(2000);
    //     // this.platform.publishEventMessage2('sample', 'v1', 'CREATION', {info: 'Done', status: false,step: 1}, timestamp, 'deploy');
    //     // await this.delay(2000);
    //     this.platform.publishEventMessage('sample', 'v1', 'CREATION', {info: 'Setting Up API aadsd', type: 'initial'}, timestamp, 'deploy');
    //     await this.delay(2000);
    //     this.platform.publishEventMessage('sample', 'v1', 'CREATION', {
    //         info: 'Setting Up API aadsd',
    //         type: 'error',
    //         description: 'error.trace()',
    //         executor_method_type: 'GET',
    //         url: 'htttp://sample.com',
    //         parameters: {},
    //         headers: {},
    //         request_body: {}
    //     }, timestamp, 'deploy');
    //     await this.delay(2000);
    //     this.platform.publishEventMessage('sample', 'v1', 'GENERATING PERMISSION', {
    //         info: 'Setting Up API adsadasd',
    //         icon: 'fa fa-cogs',
    //         type: 'inital'
    //     }, timestamp, 'deploy');
    //     await this.delay(2000);
    // }

    /*async createAPIDuplicate(){
        if (this.websocketService.checkConnection()) {
            this.connection = true ;
        } else {
            this.connection = false;
        }
        this.action = 'deploy';
        this.entityName = 'smpale';
        this.version = 'v1';
        this.apiType = 'daas';
        this.currentMessage = '';
        const timestamp = Date.now();
        await this.websocketService.checkConnection();
        this.listenAPICreation(timestamp, 'sample', 'v1');
        this.logVisible = true;
        this.logComponentRefresh = true;
        this.platform.publishEventMessage('sample', 'v1', 'CREATION', {
            info: 'creating api',
            icon: 'fa fa-edit',
            type: 'inital'
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage('sample', 'v1', 'CREATION', {
            info: 'creating api',
            type: 'error',
            description: {},
            executor_method_type: 'POST',
            executor_type:'',
            authorization : {},
            queryParameters: [],
            pathParameters: [],
            url: 'https://dev-kassu.gateway.apiplatform.io/v1/pg1',
            headers: {
                    apikey: localStorage.getItem('apikey'),
                    pkey: localStorage.getItem('partnerKey')
            },
            request_body: {
                name:'shanthan',
                age:21
            },
            executor: {},
        }, timestamp, 'deploy');
        await this.delay(2000);
        // this.platform.publishEventMessage2('sample', 'v1', 'CREATION', {info: 'Done', status: false,step: 1}, timestamp, 'deploy');
        // await this.delay(2000);
        this.platform.publishEventMessage('sample', 'v1', 'CREATION', {info: 'Setting Up API aadsd',type:'initial'}, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage('sample', 'v1', 'CREATION', {
            info: 'Setting Up API aadsd',
            type: 'error',
            description: 'error.trace()',
            executor_method_type: 'GET',
            url: 'htttp://sample.com',
            parameters: {},
            headers: {},
            request_body: {}
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage('sample', 'v1', 'GENERATING PERMISSION', {
            info: 'Setting Up API adsadasd',
            icon: 'fa fa-cogs',
            type: 'inital'
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage('sample', 'v1', 'GENERATING PERMISSION', {
            info: 'Setting Up API adsadasd dsadsadsdasd dsdasdasdasd dsadsadasdasdasd dasdasdasdasdsdsdsd   ',
            type: 'success'
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage('sample', 'v1', 'GENERATING PERMISSION', {
            info: 'Setting Up API',
            type: 'intial'
        }, timestamp, 'deploy');
         await this.delay(2000);
        this.platform.publishEventMessage('sample', 'v1', 'GENERATING PERMISSION', {
            info: 'Setting Up API',
            type: 'fatal',
            description: 'error.trace()',
            executor_method_type: 'GET',
            url: 'htttp://sample.com',
            parameters: {},
            headers: {},
            request_body: {}
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage('sample', 'v1', 'DONE', {info: '',icon:'fa fa-check'}, timestamp, 'deploy');
        this.logComponentRefresh = false;
        /!* this.platform.publishEventMessage2('sample', 'v1', 'GENERATING PERMISSION', {
            info: 'Setting Up API',
            status: false,
            step: 3
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false,
            icon: 'fa fa-shield',
            type: 'error',
            step: 0
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false,
            step: 1
        }, timestamp, 'deploy');
        await this.delay(2000);
       /!* this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false,
            type: 'fatal'
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'GATEWAY CREATION', {
            info: 'Setting Up API',
            status: false
        }, timestamp, 'deploy');*!/
        await this.delay(2000);
        this.platform.publishEventMessage2('sample', 'v1', 'DONE', {info: '', status: false, icon: 'fa fa-check', step:0}, timestamp, 'deploy');
*!/    }*/
    async createApi() {
        this.currentMessage = '';
        const timeStamp = Date.now();
        if (this.websocketService.checkConnection()) {
            this.connection = true;
        } else {
            this.connection = false;
        }
        this.action = 'deploy';
        this.entityName = this.entityName;
        this.version = this.version;
        this.listenAPICreation(timeStamp, this.entityName, this.version);
        // await this.websocketService.checkConnection();
        this.logVisible = true;
        let apiexistRes: any;
        if (this.isAPIAlreadyPresentCheckCompleted === false) {
            this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                info: 'Checking for API existence',
                type: 'initial',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            apiexistRes = await this.checkForExistingEntityAndExecutor();
        }
        if (apiexistRes === 'success') {
            this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                info: 'Checking for API existence',
                type: 'success',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                info: 'Checking for database table',
                type: 'initial',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            if (this.selectedDatatypeFilter && this.isSelectedDatabaseNatureNoSQL === false) {

                if (this.isCheckForExistingTableCompleted === false) {
                    this.invokingCheckForExistingTableFromDeploy = true;
                    if (this.previousTableName !== undefined && this.previousSelectedDatatypeFilter !== undefined) {
                        if (this.previousTableName !== this.tableName || this.previousSelectedDatatypeFilter !== this.selectedDatatypeFilter) {
                            await this.checkForExistingTableAndAttributes();
                            this.invokingCheckForExistingTableFromDeploy = false;
                        }
                    } else {
                        await this.checkForExistingTableAndAttributes();
                        this.invokingCheckForExistingTableFromDeploy = false;
                    }
                }

            }
            this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                info: 'Checking for database table',
                type: 'success',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                info: 'Checking for special characters',
                type: 'initial',
                icon: 'fa fa-newspaper-o'
            }, timeStamp, 'deploy');
            Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.entityName)).then(resp1 => {
                if (resp1 === true) {
                    Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.version)).then(resp2 => {

                        if (resp2 === true) {
                            Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_deploy_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
                                const payloadToSend = {
                                    actions: response1
                                };
                                this.dataAccessListenerInstance.dataAccessListener.emit({
                                    type: 'audit',
                                    id: localStorage.getItem('IdOfSession'),
                                    payload: payloadToSend
                                });
                            });
                            const temparray = [];
                            for (let i = 0; i < this.apiByDefinition.length; i++) {
                                if (this.apiByDefinition[i]['attributeName'] !== null && this.apiByDefinition[i]['type'] !== null) {
                                    temparray.push(this.apiByDefinition[i]);
                                }
                            }
                            this.apiByDefinition = temparray;

                            // if ((this.partnerEntities.filter(element => element.entityname === this.entityName)).length === 0) {
                            //     if ((this.partnerExecutors.filter(element => element.executor_name === this.entityName)).length === 0) {
                            //         this.isAPIAlreadyPresent = false;
                            //     } else {
                            //         if ((this.partnerExecutors.filter(element => (element.executor_version === this.version && element.executor_name === this.entityName))).length === 0) {
                            //             this.isAPIAlreadyPresent = false;
                            //         } else {
                            //             this.isAPIAlreadyPresent = true;
                            //         }
                            //     }
                            // } else {
                            //     if ((this.partnerEntities.filter(element => (element.version === this.version && element.entityname === this.entityName))).length === 0) {
                            //         this.isAPIAlreadyPresent = false;
                            //     } else {
                            //         this.isAPIAlreadyPresent = true;
                            //     }
                            // }

                            // if ((this.partnerEntities.filter(element => (element.entityname === this.entityName && element.version === this.version)).length === 0)) {
                            //     if ((this.partnerExecutors.filter(element => (element.executor_name === this.entityName && element.executor_version === this.version)).length === 0)) {
                            //         this.isAPIAlreadyPresent = false;
                            //     } else {
                            //         this.isAPIAlreadyPresent = true;
                            //     }
                            // } else {
                            //     this.isAPIAlreadyPresent = true;
                            // }

                            if (this.apiByDefinition.length === 0) {
                                // alert('Please add schema definition');
                                this.platform.openSnackBar('Please define schema under Schema Definition', 'Error', {
                                    duration: 10000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                                    info: 'Checking for special characters',
                                    type: 'fatal',
                                    icon: 'fa fa-newspaper-o',
                                    description: 'Please define schema under Schema Definition'
                                }, timeStamp, 'deploy');
                            } else if (this.tableName === undefined || this.tableName === null || this.tableName === '') {
                                this.platform.openSnackBar('Please provide a ' + this.tableLabelName + ' to create an API', 'Error', {
                                    duration: 10000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                                    info: 'Checking for special characters',
                                    type: 'fatal',
                                    icon: 'fa fa-newspaper-o',
                                    description: 'Please provide a ' + this.tableLabelName + ' to create an API'
                                }, timeStamp, 'deploy');
                            } else if (this.isAPIAlreadyPresent === true) {
                                this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                    duration: 10000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                                    info: 'Checking for special characters',
                                    type: 'fatal',
                                    icon: 'fa fa-newspaper-o',
                                    description: 'An API with the provided name and version already exists.'
                                }, timeStamp, 'deploy');
                            } else {
                                const vers = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
                                if (this.entityName !== undefined && this.entityName !== null && this.entityName.length !== 0 &&
                                    vers !== undefined && vers !== null && vers.length !== 0 &&
                                    this.apiCategory !== undefined && this.apiCategory !== null && this.apiCategory.length !== 0 &&
                                    this.methodType !== undefined && this.methodType !== null && this.methodType.length !== 0 &&
                                    this.selectDatabase !== undefined && this.selectDatabase !== null && this.selectDatabase.length !== 0 &&
                                    this.apiByDefinition[0].attributeName !== null) {

                                    this.save = false;
                                    const that = this;
                                    let entityLength = 0;
                                    let versionLength = 0;

                                    for (let i = 0; i < this.entityName.length; i++) {
                                        if (this.entityName.charCodeAt(i) === 8 || this.entityName.charCodeAt(i) === 32 || (this.entityName.charCodeAt(i) > 64 && this.entityName.charCodeAt(i) < 91) || (this.entityName.charCodeAt(i) > 96 && this.entityName.charCodeAt(i) < 123) || (this.entityName.charCodeAt(i) >= 48 && this.entityName.charCodeAt(i) <= 57)) {
                                            entityLength++;
                                        }
                                    }

                                    for (let i = 0; i < this.version.length; i++) {
                                        if (this.version.charCodeAt(i) === 8 || this.version.charCodeAt(i) === 32 || (this.version.charCodeAt(i) > 64 && this.version.charCodeAt(i) < 91) || (this.version.charCodeAt(i) > 96 && this.version.charCodeAt(i) < 123) || (this.version.charCodeAt(i) >= 48 && this.version.charCodeAt(i) <= 57)) {
                                            versionLength++;
                                        }
                                    }

                                    if (this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95) {
                                        this.isValidTableName = true;
                                    }
                                    this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                                        info: 'Checking for special characters',
                                        type: 'success',
                                        icon: 'fa fa-newspaper-o'
                                    }, timeStamp, 'deploy');
                                    const methods = [];
                                    if (this.ispublished) {
                                        this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                                            info: 'Preparing for API methods',
                                            type: 'initial',
                                            icon: 'fa fa-newspaper-o'
                                        }, timeStamp, 'deploy');
                                        this.methodType.forEach(method => {
                                            methods.push(method.id);
                                        });
                                        this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                                            info: 'Preparing for API methods',
                                            type: 'success',
                                            icon: 'fa fa-newspaper-o'
                                        }, timeStamp, 'deploy');
                                    } else {
                                        this.scopeSelected = 'private';
                                    }
                                    if (entityLength === this.entityName.length) {
                                        if (versionLength === this.version.length) {
                                            if (this.isValidTableName) {
                                                // if (!this.isSpecialCharacterInAttribute) {
                                                this.platform.publishEventMessage(this.entityName, this.version, 'API DESIGN', {
                                                    info: 'Reading schema from API design',
                                                    type: 'inital',
                                                    icon: 'fa fa-file-code-o'
                                                }, timeStamp, 'deploy');
                                                this.loading = true;
                                                const crudAPI = {
                                                    'entityname': this.entityName,
                                                    'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
                                                    'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
                                                    'displayname': this.displayName,
                                                    'description': this.description,
                                                    'published': this.ispublished,
                                                    'scopeOfAccess': this.scopeSelected,
                                                    'creationTime': Date.now(),
                                                    'lastModifiedTime': Date.now(),
                                                    'registeredAsIs': false,
                                                    'database': this.selectDatabase,
                                                    'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
                                                    'methods': methods,
                                                    'attributes': this.apiByDefinition,
                                                    'gatewayManagers': [this.selectedAPIGatewayName]
                                                };
                                                if (this.isUseExistingTable === true) {
                                                    crudAPI['tableCreation'] = false;
                                                } else {
                                                    crudAPI['tableCreation'] = true;
                                                }
                                                this.platform.publishEventMessage(this.entityName, this.version, 'API DESIGN', {
                                                    info: 'Reading schema from API design',
                                                    type: 'success',
                                                    icon: 'fa fa-file-code-o'
                                                }, timeStamp, 'deploy');
                                                this.platform.publishEventMessage(this.entityName, this.version, 'API DEVELOPMENT', {
                                                    info: 'Generating code for the schema',
                                                    type: 'initial',
                                                    icon: 'fa fa-edit'
                                                }, timeStamp, 'deploy');
                                                this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(async data => {
                                                    if (data && data['message'] === 'API already exists.') {
                                                        this.save = false;
                                                        this.loading = false;
                                                        this.platform.openSnackBar(data['message'], 'Error', {
                                                            duration: 5000,
                                                            verticalPosition: 'top',
                                                            horizontalPosition: 'center'
                                                        });
                                                        this.platform.publishEventMessage(this.entityName, this.version, 'API DEVELOPMENT', {
                                                            info: 'Generating code for the schema',
                                                            type: 'fatal',
                                                            icon: 'fa fa-edit',
                                                            description: 'API already exist'
                                                        }, timeStamp, 'deploy');
                                                        //this.platform.publishEventMessage(this.entityName, this.version,'CREATION', 'API already exists');
                                                    } else {
                                                        this.platform.publishEventMessage(this.entityName, this.version, 'API DEVELOPMENT', {
                                                            info: 'Generating code for the schema',
                                                            type: 'success'
                                                        }, timeStamp, 'deploy');
                                                        await this.delay(2000);
                                                        this.platform.publishEventMessage(this.entityName, this.version, 'API TESTING', {
                                                            info: 'Checking for testcases <br>Testcases found: 0',
                                                            icon: 'fa fa-check-square-o',
                                                            type: 'initial'
                                                        }, timeStamp, 'deploy');
                                                        this.platform.publishEventMessage(this.entityName, this.version, 'API TESTING', {
                                                            info: 'Checking for testcases <br>Testcases found: 0',
                                                            icon: 'fa fa-check-square-o',
                                                            type: 'success'
                                                        }, timeStamp, 'deploy');
                                                        this.platform.publishEventMessage(this.entityName, this.version, 'API DEPLOYMENT', {
                                                            info: 'Deploying API',
                                                            type: 'initial',
                                                            icon: 'fa fa-cloud-upload'
                                                        }, timeStamp, 'deploy');

                                                        await this.platform.createAPIAuditLog(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI['entityname'], crudAPI['version'], 'DAAS', crudAPI);
                                                        //this.platform.publishEventMessage(this.entityName, this.version,'CONFIGURING PLATFORM PERMISSIONS', {info:'Configuring platform permissions for data access service',type:'inital', icon: 'fa fa-cogs'}, timeStamp, 'deploy');
                                                        await Promise.resolve(this.platform.generateAccountRolePermissionGroupAndPermissions(this.partner, this.account_id, localStorage.getItem('signInEmail'), this.entityName, this.version, 'DAAS', true, timeStamp, 'deploy')).then(async resp => {
                                                            //  this.platform.publishEventMessage(this.entityName, this.version,'CONFIGURING PLATFORM PERMISSIONS', {info:'Configuring platform permissions for data access service',type:'success', icon: 'fa fa-cogs'}, timeStamp, 'deploy');
                                                            await this.delay(2000);
                                                        }, async error => {
                                                            //  this.platform.publishEventMessage(this.entityName, this.version,'GENERATING_PERMISSION', {info:'Permissions creation failed' ,type:'error', icon: 'fa fa-shield'}, timeStamp, 'deploy');
                                                            await this.delay(2000);
                                                        });
                                                        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_deploy_success', 'INFO', data.status, data.statusText, '', crudAPI, data, this.router.url)).then(response => {
                                                            const payloadToSend = {
                                                                actions: response
                                                            };
                                                            this.dataAccessListenerInstance.dataAccessListener.emit({
                                                                type: 'audit',
                                                                id: localStorage.getItem('IdOfSession'),
                                                                payload: payloadToSend
                                                            });
                                                        });
                                                        //this.platform.publishEventMessage(this.entityName, this.version,'DEPLOYING API', {info:'Deploying API',type:'initial', icon: 'fa fa-cogs'}, timeStamp, 'deploy');
                                                        if (this.ispublished) {
                                                            this.Blocks = [1, 2, 3, 4, 5];
                                                            const blockLength = this.Blocks.length;
                                                            const blockStart = this.BlockList[this.Blocks[0]];
                                                            const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                                            this.progress = blockStart;
                                                            this.save = true;
                                                            //that.setInterval(blockEnd, true);
                                                            // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                                                            this.confPost.getApiExecutorsByPartnerAccountType(localStorage.getItem('partner'), localStorage.getItem('account'), 'API').subscribe(data => {
                                                                // localStorage.setItem('dataAccessAPI' , JSON.stringify(data));
                                                                this.platform.apiExecutors = data;
                                                                // localStorage.setItem('isDataAccessAPISet', 'true');
                                                                this.platform.isDataAccessAPISet = 'true';
                                                                // localStorage.setItem('updatedDataAccessAPI', JSON.stringify({'entityName': crudAPI['entityname'], 'version': crudAPI['version']}));
                                                                this.platform.updatedDataAccessAPI = JSON.stringify({
                                                                    'entityName': crudAPI['entityname'],
                                                                    'version': crudAPI['version']
                                                                });
                                                            });
                                                        } else {
                                                            this.Blocks = [1, 2, 3];
                                                            this.save = true;
                                                            const blockLength = this.Blocks.length;
                                                            const blockStart = this.BlockList[this.Blocks[0]];
                                                            const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                                                            this.progress = blockStart;
                                                            //that.setInterval(blockEnd, true);
                                                            // this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                                                            this.leftPanelDataListener.changeInLeftPanelDataV2.emit('dataaccess');
                                                        }
                                                        await this.delay(2000);
                                                        this.platform.publishEventMessage(this.entityName, this.version, 'API DEPLOYMENT', {
                                                            info: 'Deploying API',
                                                            type: 'success',
                                                            icon: 'fa fa-cloud-upload'
                                                        }, timeStamp, 'deploy');
                                                        if (this.ispublished) {
                                                            // this.configureApiGateway();
                                                            //this.platform.publishEventMessage(this.entityName, this.version,'API GATEWAY MANAGEMENT', {info:'Configuring Gateway Settings for the API',type:'initial', icon: 'fa fa-shield'}, timeStamp, 'deploy');
                                                            await this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false, methods, timeStamp, 'deploy');
                                                            //this.platform.publishEventMessage(this.entityName, this.version,'CONFIGURING API GATEWAY AND ACCESS POLICIES', {info:'Configuring Gateway Settings for the API',type:'success', icon: 'fa fa-shield'}, timeStamp, 'deploy');
                                                            this.platform.publishEventMessage(this.entityName, this.version, 'API DOCUMENTATION', {
                                                                info: 'Generating Documents',
                                                                type: 'initial',
                                                                icon: 'fa fa-book'
                                                            }, timeStamp, 'deploy');
                                                            this.platform.publishEventMessage(this.entityName, this.version, 'API DOCUMENTATION', {
                                                                info: 'Generating Documents',
                                                                type: 'success',
                                                                icon: 'fa fa-book'
                                                            }, timeStamp, 'deploy');
                                                            this.platform.publishEventMessage(this.entityName, this.version, 'DONE', {
                                                                info: '',
                                                                type: 'success',
                                                                icon: 'fa fa-check'
                                                            }, timeStamp, 'deploy');
                                                            this.loading = false;
                                                            if (!this.connection) {
                                                                this.platform.openSnackBar('API Deployed Successfully', 'Success', {
                                                                    duration: 10000,
                                                                    verticalPosition: 'top',
                                                                    horizontalPosition: 'center'
                                                                });
                                                            }
                                                            // this.confPost.getApiExecutorsByPartnerAccountEntityVersion(this.partner, this.account_id, this.entityName, this.version).subscribe(data=>{
                                                            //     if (data) {
                                                            //         this.operations = data;
                                                            //         this.selectedCredentialTabIndex = 2;
                                                            //     }
                                                            // });
                                                        }
                                                    }
                                                }, error => {
                                                    this.loading = false;
                                                    let errorMessage = '';
                                                    if (error.error) {
                                                        if (error.error['message']) {
                                                            errorMessage = error.error.message;
                                                        } else {
                                                            errorMessage = error.error;
                                                        }
                                                    } else {
                                                        errorMessage = 'Error while creating the API. Please try again sometime.';
                                                    }
                                                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'dataaccessapi_create_deploy_failed', 'ERROR', error.status, error.statusText, errorMessage, crudAPI, error, this.router.url)).then(response => {
                                                        const payloadToSend = {
                                                            actions: response
                                                        };
                                                        this.dataAccessListenerInstance.dataAccessListener.emit({
                                                            type: 'audit',
                                                            id: localStorage.getItem('IdOfSession'),
                                                            payload: payloadToSend
                                                        });
                                                    });

                                                    this.save = false;
                                                    // this.ispublished = false;
                                                    // this.platform.openSnackBar('Error while adding Entity', 'Error', {
                                                    //     duration: 5000,
                                                    //     verticalPosition: 'top',
                                                    //     horizontalPosition: 'center'
                                                    // });
                                                    this.platform.handleErrorGracefully(error, 'Error while creating the API. Please try again sometime.');
                                                });


                                                // if (this.ispublished) {
                                                //     // this.configureApiGateway();
                                                //     this.kongService.configureApiGatewayWithIpRestrictionWithMethods(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false, methods);
                                                // }

                                                // } else {
                                                //     this.platform.openSnackBar('Special characters are not allowed in attribute name', 'Error', {
                                                //         duration: 5000,
                                                //         verticalPosition: 'top',
                                                //         horizontalPosition: 'center'
                                                //     });
                                                // }
                                            } else {
                                                this.platform.openSnackBar('Special characters are not allowed at the beginning of a table name.', 'Error', {
                                                    duration: 5000,
                                                    verticalPosition: 'top',
                                                    horizontalPosition: 'center'
                                                });
                                            }
                                        } else {
                                            this.platform.openSnackBar('Special characters are not allowed in Version', 'Error', {
                                                duration: 5000,
                                                verticalPosition: 'top',
                                                horizontalPosition: 'center'
                                            });
                                        }
                                    } else {
                                        this.platform.openSnackBar('Special characters are not allowed in API Name', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }
                                } else {

                                    if (this.entityName === undefined || this.entityName === '' || this.entityName === null || this.entityName.length === 0) {
                                        // this.platform.openSnackBar('Please enter a valid name for Data Access Service', 'Error', {
                                        //     duration: 5000,
                                        //     verticalPosition: 'top',
                                        //     horizontalPosition: 'center'
                                        // });

                                        this.platform.openSnackBar('Please enter a valid name for Data Access Service.', 'Error', null);

                                    } else if (vers === undefined || vers === '' || vers === null || vers === 0) {
                                        this.platform.openSnackBar('Please enter a valid version for Data Access Service', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    } else if (this.apiCategory === undefined || this.apiCategory === '' || this.apiCategory === null || this.apiCategory.length === 0) {
                                        this.platform.openSnackBar('Please enter a valid category for Data Access Service', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    } else if (this.selectDatabase === undefined || this.selectDatabase === null || this.selectDatabase.length === 0) {
                                        this.platform.openSnackBar('Please select a database to create this service', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    } else if (this.methodType === undefined || this.methodType === [] || this.methodType === null || this.methodType.length === 0) {
                                        this.platform.openSnackBar('You need to select at least one Method Type to create this service', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    } else if (this.apiByDefinition[0].attributeName === null) {
                                        this.platform.openSnackBar('You need to select at least one Attribute to create this service', 'Error', {
                                            duration: 5000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                    }
                                }
                            }
                        } else {
                            this.loading = false;
                            this.platform.openSnackBar('Entity version should not have any special characters or spaces in between', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                                info: 'Checking for special characters',
                                type: 'fatal',
                                icon: 'fa fa-newspaper-o',
                                description: 'Entity version should not have any special characters or spaces in between'
                            }, timeStamp, 'deploy');
                        }
                    });
                } else {
                    this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                        info: 'Checking for special characters',
                        type: 'fatal',
                        icon: 'fa fa-newspaper-o',
                        description: 'Entity name should not have any special characters or spaces in between'
                    }, timeStamp, 'deploy');

                    // this.platform.publishEventMessage(this.entityName, this.version,'API REQUIREMENTS', {info: 'Checking for special characters', type: 'initial', icon : 'fa fa-clone'}, timeStamp, 'deploy');
                    this.loading = false;
                    this.platform.openSnackBar('Entity name should not have any special characters or spaces in between', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            });

        } else {
            this.platform.publishEventMessage(this.entityName, this.version, 'API REQUIREMENTS', {
                info: 'Checking for API existence',
                type: 'fatal',
                icon: 'fa fa-newspaper-o',
                description: 'Invalid API Name and Version'
            }, timeStamp, 'deploy');
        }

    }

    closeLogPanel() {
        this.logVisible = false;
        if (this.location['_platformLocation'].location.pathname === '/dataaccessapi') {
            this.confPost.getEntityForPartner(this.partner, this.account_id, this.partnerKey, this.entityName, this.version).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
                }
            });
        }
    }

    createApiWithCoreApi() {
        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;
        this.logVisible = false;

        if (this.websocketService.isOpen()) {
            this.connection = true;
            this.logVisible = true;
        } else {
            this.connection = false;
        }
        this.action = 'deploy';
        this.entityName = this.entityName;
        this.version = this.version;
        this.loading = true;
        this.listenAPICreation(timeStamp, this.entityName, this.version);

        const methods = [];
        if (this.ispublished) {
            this.methodType.forEach(method => {
                methods.push(method.id);
            });
        }

        const gateways = this.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                gatewaySettings.push({name: gateway});
            }
        }

        const category = ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory);
        const vers = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
        const topic = localStorage.getItem('partner') + '.' + localStorage.getItem('account')  + '.' + this.entityName + '.' + this.version + '.' + localStorage.getItem('sessionID') + '.' + timeStamp.toString() + '.' + this.action;
        const temparray = [];
        for (let i = 0; i < this.apiByDefinition.length; i++) {
            if (this.apiByDefinition[i]['attributeName'] !== null && this.apiByDefinition[i]['type'] !== null) {
                temparray.push(this.apiByDefinition[i]);
            }
        }

        const entity = {
            'entityname': this.entityName,
            'category': ((typeof category) === 'object' ? category['name'] : category),
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayname': this.displayName,
            'description': this.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'registeredAsIs': false,
            'database': this.selectDatabase,
            'version': vers,
            'methods': methods,
            'attributes': temparray,
            'gatewaySettings': gatewaySettings
        };



        if (this.isUseExistingTable === true) {
            entity['tableCreation'] = false;
        } else {
            entity['tableCreation'] = true;
        }

        const crudApi1 = {
            'topic': topic,
            'apiModel': entity
        };

        if (this.entityName !== undefined && this.entityName !== null && this.entityName.length !== 0 &&
            vers !== undefined && vers !== null && vers !== 0 &&
            category !== undefined && category !== null && category.length !== 0 &&
            methods !== undefined && methods !== null && methods.length !== 0 &&
            this.selectDatabase !== undefined && this.selectDatabase !== null && this.selectDatabase.length !== 0 &&
            this.apiByDefinition && this.apiByDefinition.length && this.apiByDefinition[0].attributeName !== null &&
            this.tableName !== undefined && this.tableName !== null && this.tableName.length !== 0 && (gatewaySettings && gatewaySettings.length !==0) &&
            (this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95)) {

            this.loading = true;
            if (this.connection === false) {
                this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                    data: {
                        message: 'API deployment is under progress. Please don\'t close the window'
                    }
                });
            } else {
                this.logVisible = true;
            }

            this.confPost.upsertAPIWithCore(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey'), crudApi1, true, false, true, true).toPromise().then(response => {

                this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
                if (!this.websocketService.isOpen()) {
                    this.logVisible = true;
                    this.refreshLogCount++;
                }
                const log_payload = {
                    logType: 'INFO',
                    logLevel: 2,
                    slugSearch: '',
                    label: 'BUTTON_CLICK',
                    featureArea: this.platform.auditFeatureArea.dass,
                    resource: 'DEPLOY',
                    action: 'CLICK',
                    result: 'SUCCESS',
                    payload: crudApi1,
                    responseStatusCode: 200,
                    response: response,
                    errorMessage: '',
                    logMessage: 'API deployed'
                };
                this.auditLog.log(log_payload);
            }, error => {

                this.loading = false;
                if (this.showDialogOnNonWebsocketConnection) {
                    this.showDialogOnNonWebsocketConnection.close();
                }
                if (!this.websocketService.isOpen()) {
                    this.logVisible = true;
                    this.refreshLogCount++;
                }
                const log_payload = {
                    logType: 'INFO',
                    logLevel: 2,
                    slugSearch: '',
                    label: 'BUTTON_CLICK',
                    featureArea: this.platform.auditFeatureArea.dass,
                    resource: 'DEPLOY',
                    action: 'CLICK',
                    result: 'FAIL',
                    payload: crudApi1,
                    responseStatusCode: error.status,
                    response: error,
                    errorMessage: error.message,
                    logMessage: 'Error in API deployment'
                };
                this.auditLog.log(log_payload);
            });
        } else {
            this.loading = false;

            if (this.entityName === undefined || this.entityName === null || this.entityName.length === 0 ||
                vers === undefined || vers === null || vers === 0 ||
                category === undefined || category === null || category.length === 0 ||
                methods === undefined || methods === null || methods.length === 0 ||
                this.selectDatabase === undefined || this.selectDatabase === null || this.selectDatabase.length === 0 ||
                entity.tableName === undefined || entity.tableName === null || entity.tableName.length === 0) {
                this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (!(gatewaySettings && gatewaySettings.length !==0)) {
                this.platform.openSnackBar('Please select at least one API Gateway.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (!(this.apiByDefinition && this.apiByDefinition.length && this.apiByDefinition[0].attributeName !== null)) {
                this.platform.openSnackBar('Please define a valid schema.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (!(this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95)) {
                this.platform.openSnackBar('Please enter a valid ' + this.tableLabelName, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }

    }

    async createApiFromService() {
        this.currentMessage = '';
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;
        this.logVisible = false;

        if (this.websocketService.isOpen()) {
            this.connection = true;
            // this.logVisible = true;
        } else {
            this.connection = false;
        }
        this.action = 'deploy';
        this.entityName = this.entityName;
        this.version = this.version;
        this.loading = true;
        this.listenAPICreation(timeStamp, this.entityName, this.version);

        Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '1', this.router.url, 'BUTTON_CLICK', this.platform.auditFeatureArea.dass, 'DEPLOY_BUTTON', 'CLICK', 'SUCCESS', '', 200, '', 'Deploy button clicked')).then(response => {
            this.auditListenerService.auditListener.emit({
                type: 'auditLog',
                category: 'isAuditForDataAccess',
                payload: response
            });
        });

        if (this.selectedDatatypeFilter && this.isSelectedDatabaseNatureNoSQL === false) {

            if (this.isCheckForExistingTableCompleted === false) {
                this.invokingCheckForExistingTableFromDeploy = true;
                if (this.previousTableName !== undefined && this.previousSelectedDatatypeFilter !== undefined) {
                    if (this.previousTableName !== this.tableName || this.previousSelectedDatatypeFilter !== this.selectedDatatypeFilter) {
                        await this.checkForExistingTableAndAttributes();
                        this.invokingCheckForExistingTableFromDeploy = false;
                    }
                } else {
                    await this.checkForExistingTableAndAttributes();
                    this.invokingCheckForExistingTableFromDeploy = false;
                }
            }
        }
        const methods = [];
        if (this.ispublished) {
            this.methodType.forEach(method => {
                methods.push(method.id);
            });
        }

        const category = ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory);
        const vers = ((typeof this.version) === 'object' ? this.version['name'] : this.version);

        const entity = {
            'entityName': this.entityName,
            'apiCategory': category,
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayName': this.displayName,
            'description': this.description,
            'ispublished': this.ispublished,
            'scopeSelected': this.scopeSelected,
            'registeredAsIs': false,
            'selectDatabase': this.selectDatabase,
            'version': vers,
            'methods': methods,
            'apiByDefinition': this.apiByDefinition,
            'selectedGatewayName': this.selectedAPIGatewayName,
            'timeStamp': timeStamp,
            'action': this.action
        };
        if (this.isUseExistingTable === true) {
            entity['tableCreation'] = false;
        } else {
            entity['tableCreation'] = true;
        }

        if (this.entityName !== undefined && this.entityName !== null && this.entityName.length !== 0 &&
            vers !== undefined && vers !== null && vers !== 0 &&
            category !== undefined && category !== null && category.length !== 0 &&
            methods !== undefined && methods !== null && methods.length !== 0 &&
            this.selectDatabase !== undefined && this.selectDatabase !== null && this.selectDatabase.length !== 0 &&
            this.apiByDefinition && this.apiByDefinition.length && this.apiByDefinition[0].attributeName !== null &&
            this.tableName !== undefined && this.tableName !== null && this.tableName.length !== 0 &&
            (this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95)) {

            await this.CheckForExistingEntityOrExecutor();

            if (this.isAPIAlreadyPresent) {
                this.loading = false;
                this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                this.loading = true;
                if (this.connection === false) {
                    this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                        maxWidth: '95vw',
                        maxHeight: '60vh',
                        data: {
                            message: 'API deployment is under progress. Please don\'t close the window'
                        }
                    });
                } else {
                    this.logVisible = true;
                }
                this.apiCreatorService.createDaa([entity]);
            }
        } else {
            this.loading = false;

            if (this.entityName === undefined || this.entityName === null || this.entityName.length === 0 ||
                vers === undefined || vers === null || vers === 0 ||
                category === undefined || category === null || category.length === 0 ||
                methods === undefined || methods === null || methods.length === 0 ||
                this.selectDatabase === undefined || this.selectDatabase === null || this.selectDatabase.length === 0 ||
                entity.tableName === undefined || entity.tableName === null || entity.tableName.length === 0) {
                this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (!(this.apiByDefinition && this.apiByDefinition.length && this.apiByDefinition[0].attributeName !== null)) {
                this.platform.openSnackBar('Please define a valid schema.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else if (!(this.tableName.charCodeAt(0) !== 35 && this.tableName.charCodeAt(0) !== 36 && this.tableName.charCodeAt(0) !== 64 && this.tableName.charCodeAt(0) !== 95)) {
                this.platform.openSnackBar('Please enter a valid ' + this.tableLabelName, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }
    }


    reInitializeAPIDefinition() {
        this.apiByDefinition = [{
            'customType': false,
            'apiAccessPolicy': 'None',
            'attributeName': null,
            'type': null,
            'array': false,
            'size': null,
            'precision': null,
            'autoIncrement': false,
            'defaultValue': null,
            'attributeType': 'None',
            'dataStoragePolicy': 'None',
            'description': null,
            'displayName': null,
            'displayPolicy': 'None',
            'required': false,
            'subType': []

        }];
        this.isAPIDefinitionImportedFromExistingTable = false;
    }

    // getCustomTypes(val) {
    //     return new Promise((resolve, reject) => {
    //         this.confPost.getEntityNameAndVersionAsCustomTypeWithParams(localStorage.getItem('partner'), localStorage.getItem('account'), val).subscribe(response => {
    //                 if (response.status === 200) {
    //                     this.entityAndVersion = response.body['entityNameAndVersion'];
    //                     resolve('success');
    //                 } else {
    //                     this.entityAndVersion = [];
    //                     resolve('failed');
    //                 }
    //             },
    //             error => {
    //                 this.entityAndVersion = [];
    //                 this.platform.handleErrorGracefully(error, 'Error while getting entity name and version for partner account. Please try again after sometime.');
    //                 resolve('success');
    //             });
    //     });
    // }

    getDefaultGatewaySettings(settingsData) {
        if (settingsData && settingsData['body']) {
            for (const envs of settingsData['body'][0]['environments']) {
                if (envs && envs !== null && envs !== undefined) {
                    if (envs['name'] === localStorage.getItem('partner')) {
                        if (envs['services']) {
                            const gatewayService = envs['services'].filter(element => element.type === 'apigateway');
                            if (gatewayService[0]['configurations'] && gatewayService[0]['configurations'] !== null && gatewayService[0]['configurations'] !== undefined && gatewayService[0]['configurations'].length > 0) {
                                this.APIGateways = gatewayService[0]['configurations'];
                            }
                            for (const gateway of gatewayService[0]['configurations']) {
                                if (gateway && gateway !== null && gateway !== undefined && gateway['is_default'] === true && gateway['gateway_configurations'] !== {}) {
                                    this.platform.defaultGatewaySettings = gateway['gateway_configurations'];
                                    this.selectedAPIGateway = gateway;
                                    this.selectedAPIGatewayName = gateway['name'];
                                }
                            }
                        }
                    }
                }
            }
        }
    }


    async filterDataTypes(val) {
        this.getDatabaseTypeForDatabaseName(val);
        this.dataTypeFilter = [];
        this.datatypes.filter(items => {
            if (items.database_type === this.selectedDatatypeFilter) {
                items.data_types[0]['description'] =  this.getDescription(items.data_types[0].type);
                // To check descriptions of each data type
                // console.log("Data Type-> ", items.data_types[0].type);
                // console.log("Description-> ", items.data_types[0].description);
                // console.log("");
                this.dataTypeFilter.push(items);
            }
        });
        if (this.selectedDatatypeFilter && this.selectedDatatypeFilter === 'mongodb') {
            await this.platform.getCustomTypes(val);
            this.entityAndVersion = this.platform.entityAndVersion;
        } else {
            this.entityAndVersion = [];
        }
        if (this.entityAndVersion) {
            for (let i = 0; i < this.entityAndVersion.length; i++) {
                const newType = {
                    'database_type': 'mongodb',
                    'data_types': [
                        {
                            'type': this.entityAndVersion[i],
                            'default_length': '',
                            'min_length': '',
                            'max_length': ''
                        }]
                };
                this.dataTypeFilter.push(newType);
            }
        }
        if (this.selectedDatatypeFilter === 'mongodb') {
            this.tableLabelName = 'Collection Name';
        } else {
            this.tableLabelName = 'Table Name';
        }
    }

    getDatabaseTypeForDatabaseName(val) {
        this.databases.filter(items => {
            if (items.database_name === val) {
                this.selectedDatatypeFilter = items.database_type;
                if (items.hasOwnProperty('is_nosql')) {
                    this.isSelectedDatabaseNatureNoSQL = items.is_nosql;
                }
            }
        });
    }

    hasViewPagePermissions() {
        if (this.fromHistory === true) {
            return (this.platform.hasPermissions(['EDIT_HISTORY', 'CREATE_DATA_ACCESS_API']));
        } else {
            return this.platform.hasPlatformPermission('CREATE_DATA_ACCESS_API');
        }
    }

    displayFn(user?: ICategory): string | undefined {
        return user ? user.name : undefined;
    }

    displayVersion(version?: EntityVersions): string | undefined {
        return version ? version.name : undefined;
    }

    onPaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData;
        const attributeName = clipboardData.getData('text');
        let attributeLength = 0;

        for (let i = 0; i < attributeName.length; i++) {
            if (attributeName.charCodeAt(i) === 8 || attributeName.charCodeAt(i) === 32 || (attributeName.charCodeAt(i) > 64 && attributeName.charCodeAt(i) < 91) || (attributeName.charCodeAt(i) > 96 && attributeName.charCodeAt(i) < 123) || (attributeName.charCodeAt(i) >= 48 && attributeName.charCodeAt(i) <= 57)) {
                attributeLength++;
            }
        }

        if (attributeLength !== attributeName.length) {
            this.isSpecialCharacterInAttribute = true;
        } else {
            this.isSpecialCharacterInAttribute = false;
        }

    }

    saveAPI() {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_save_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response1 => {
            const payloadToSend = {
                actions: response1
            };
            this.dataAccessListenerInstance.dataAccessListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        const methods = [];
        this.methodType.forEach(method => {
            methods.push(method.id);
        });

        const savePayload = {
            partner: '',
            account: '',
            executor_name: '',
            executor_type: '',
            by: '',
            executor_version: '',
            action: ''
        };

        savePayload.partner = this.partner;
        savePayload.account = this.account_id;
        savePayload['at'] = Date.now();
        savePayload.by = this.partner;

        if (this.entityName !== null && this.entityName !== undefined && this.entityName !== '') {
            savePayload.executor_name = this.entityName;
        } else {
            savePayload.executor_name = Date.now().toString();
        }

        savePayload.executor_version = ((typeof this.version) === 'object' ? this.version['name'] : this.version);
        savePayload.action = 'CREATE';
        savePayload.executor_type = 'API';

        const crudAPI = {
            'entityname': this.entityName,
            'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayname': this.displayName,
            'description': this.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': this.selectDatabase,
            'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'methods': methods,
            'attributes': this.apiByDefinition,
            'gatewayManagers': [this.selectedAPIGatewayName]
        };
        if (this.isUseExistingTable === true) {
            crudAPI['tableCreation'] = false;
        } else {
            crudAPI['tableCreation'] = true;
        }
        savePayload['executor'] = crudAPI;
        const temp = JSON.parse(JSON.stringify(savePayload['executor']));
        let isSame = true;
        if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
            if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
                const keyArray = Object.keys(this.previousSavedData);
                for (const key of keyArray) {
                    if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                        continue;
                    } else {
                        isSame = false;
                        break;
                    }
                }
            } else {
                isSame = false;
            }
        } else {
            isSame = false;
        }

        if (isSame === false) {
            this.confPost.saveExecutorInformation('v1', savePayload).subscribe(data => {
                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'dataaccessapi_create_save_success', 'INFO', data.status, data.statusText, '', crudAPI, data, this.router.url)).then(response => {
                    const payloadToSend = {
                        actions: response
                    };
                    this.dataAccessListenerInstance.dataAccessListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });

                // Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, 'API_SAVE',
                //     this.platform.auditFeatureArea.dass, 'API_SAVE', 'SAVE', 'SUCCESS', crudAPI,
                //     data.status, data.statusText, 'API saved')).then(response => {
                //     this.auditListenerService.auditListener.emit({
                //         type: 'auditLog',
                //         category: 'isAuditForDataAccess',
                //         payload: response
                //     });
                // });

                const log_payload = {
                    logType: 'INFO',
                    logLevel: 0,
                    slugSearch: '',
                    label: 'API_SAVE',
                    featureArea: this.platform.auditFeatureArea.dass,
                    resource: 'API_SAVE',
                    action: 'SAVE',
                    result: 'SUCCESS',
                    payload: crudAPI,
                    responseStatusCode: data.status,
                    response: data.statusText,
                    errorMessage: '',
                    logMessage: 'API saved'
                };
                this.auditLog.log(log_payload);

                this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
            }, error => {

                Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, 'API_SAVE', this.platform.auditFeatureArea.dass, 'API_SAVE', 'SAVE', 'FAIL', crudAPI, error.status, '', error.statusText)).then(response => {
                    this.auditListenerService.auditListener.emit({
                        type: 'auditLog',
                        category: 'isAuditForDataAccess',
                        payload: response
                    });
                });
                const log_payload = {
                    logType: 'ERROR',
                    logLevel: 0,
                    slugSearch: '',
                    label: 'API_SAVE',
                    featureArea: this.platform.auditFeatureArea.dass,
                    resource: 'API_SAVE',
                    action: 'SAVE',
                    result: 'FAIL',
                    payload: crudAPI,
                    responseStatusCode: error.status,
                    response: '',
                    errorMessage: '',
                    logMessage: error.statusText
                };
                this.auditLog.log(log_payload);

                this.platform.handleErrorGracefully(error, 'Error while saving the API. Please try again after sometime.');
            });
        } else {
            this.platform.openSnackBar('No changes to save for this Data Access API.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    checkForExistingTableOnFocusOut() {
        // if (this.previousTableName !== undefined && this.previousSelectedDatatypeFilter !== undefined) {
        //     if (this.previousTableName !== this.tableName || this.previousSelectedDatatypeFilter !== this.selectedDatatypeFilter) {
        //         // this.reInitializeAPIDefinition();
        //     }
        // } else {
        //     // this.reInitializeAPIDefinition();
        // }
        // this.isAPIDefinitionImportedFromExistingTable = false;
        setTimeout(() => {
            if (this.invokingCheckForExistingTableFromDeploy === false) {
                this.checkForExistingTable();
            }
        }, 500);
    }

    checkForExistingTableAndAttributes() {
        return new Promise((resolve, reject) => {
            const deleteDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.confPost.checkIfTableExists(this.partner, this.tableName, this.selectDatabase, this.selectedDatatypeFilter).subscribe(response => {
                if (response && response !== undefined && response !== null) {
                    deleteDialog.close();
                    const dialogRef = this.dialog.open(UseExistingTableConfirmationComponent, {
                        width: 'auto',
                        height: 'auto',
                        data: {
                            message: 'Checking for table existence...'
                        }
                    });
                    dialogRef.afterClosed().subscribe(result => {
                        if (result) {
                            if (result === 'yes') {
                                const deleteDialog1 = this.dialog.open(LoaderWithProgressComponent, {
                                    maxWidth: '95vw',
                                    maxHeight: '60vh',
                                    data: {
                                        message: 'Retrieving existing table attributes...'
                                    }
                                });
                                this.confPost.getTableAttributes(this.partner, this.tableName, this.selectDatabase, this.selectedDatatypeFilter).subscribe(response1 => {
                                    if (response1) {
                                        this.isUseExistingTable = true;
                                        this.isCheckForExistingTableCompleted = false;
                                        deleteDialog1.close();
                                        this.apiByDefinition = response1;
                                        this.isAPIDefinitionImportedFromExistingTable = true;
                                        this.previousTableName = this.tableName;
                                        this.previousSelectedDatatypeFilter = this.selectedDatatypeFilter;
                                        resolve('success');
                                    } else {
                                        this.platform.openSnackBar('Error while retrieving the existing table attributes. Please try again after sometime.', 'Error', {
                                            duration: 10000,
                                            verticalPosition: 'top',
                                            horizontalPosition: 'center'
                                        });
                                        this.isCheckForExistingTableCompleted = false;
                                        deleteDialog1.close();
                                        this.router.navigateByUrl('/controlplane');
                                    }
                                }, error => {
                                    this.isCheckForExistingTableCompleted = false;
                                    deleteDialog1.close();
                                    this.platform.handleErrorGracefully(error, 'Error while retrieving the existing table attributes. Please try again after sometime.');
                                    this.router.navigateByUrl('/controlplane');
                                });
                            } else {
                                this.isUseExistingTable = false;
                                this.tableName = '';
                                this.tableNameField.nativeElement.focus();
                                this.isCheckForExistingTableCompleted = false;
                                resolve('success');
                            }
                        } else {
                            this.isUseExistingTable = false;
                            this.tableName = '';
                            this.tableNameField.nativeElement.focus();
                            this.isCheckForExistingTableCompleted = false;
                            resolve('success');
                        }
                    });
                } else {
                    this.isUseExistingTable = false;
                    this.previousTableName = this.tableName;
                    this.previousSelectedDatatypeFilter = this.selectedDatatypeFilter;
                    this.isCheckForExistingTableCompleted = false;
                    resolve('success');
                    deleteDialog.close();
                }

            }, error => {
                deleteDialog.close();
                this.platform.handleErrorGracefully(error, 'Error while checking the existing tables in your account. Please try again after sometime.');
                this.router.navigateByUrl('/controlplane');
            });
        });
    }

    checkForExistingTable() {
        return new Promise(async (resolve, reject) => {
            if (this.tableName !== undefined && this.selectedDatatypeFilter !== undefined) {
                if (this.isCheckForExistingTableCompleted === false) {
                    if (this.previousTableName !== undefined && this.previousSelectedDatatypeFilter !== undefined) {
                        if (this.selectedDatatypeFilter && this.isSelectedDatabaseNatureNoSQL === false) {
                            if (this.tableName !== undefined && this.tableName !== '' && this.tableName !== null && this.selectedDatatypeFilter !== undefined && this.selectedDatatypeFilter !== '' && this.selectedDatatypeFilter !== null) {
                                if (this.tableName !== this.previousTableName || this.selectedDatatypeFilter !== this.previousSelectedDatatypeFilter) {
                                    this.isCheckForExistingTableCompleted = true;
                                    await this.checkForExistingTableAndAttributes();
                                    resolve('success');
                                }
                            }
                        }
                    } else {
                        if (this.selectedDatatypeFilter && this.isSelectedDatabaseNatureNoSQL === false) {
                            if (this.tableName !== undefined && this.tableName !== '' && this.tableName !== null && this.selectedDatatypeFilter !== undefined && this.selectedDatatypeFilter !== '' && this.selectedDatatypeFilter !== null) {
                                this.isCheckForExistingTableCompleted = true;
                                await this.checkForExistingTableAndAttributes();
                                resolve('success');
                            }
                        }
                    }
                } else {
                    resolve('success');
                }
            }
        });
    }

    checkForExistingEntityAndExecutorFromFocusOut() {
        setTimeout(() => {
            this.checkForExistingEntityAndExecutor();
        }, 500);
    }

    CheckForExistingEntityOrExecutor() {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.entityName, this.version)).then(response => {
                this.isAPIAlreadyPresent = false;
                this.isAPIAlreadyPresentCheckCompleted = false;
                this.previouslyCheckedName = this.entityName;
                this.previouslyCheckedVersion = this.version;
                resolve('success');
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.entityName;
                        this.previouslyCheckedVersion = this.version;
                        resolve('failed');
                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else if (error.status === 'failed') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.entityName;
                        this.previouslyCheckedVersion = this.version;
                        resolve('failed');
                        this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }
            });
        });
    }

    checkForExistingEntityAndExecutor() {
        return new Promise(async (resolve, reject) => {
            if (this.entityName !== null && this.entityName !== undefined && this.entityName !== '' && this.version !== null && this.version !== undefined && this.version !== '') {
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
                        if (this.previouslyCheckedName !== this.entityName || this.previouslyCheckedVersion !== this.version) {
                            this.isAPIAlreadyPresentCheckCompleted = true;
                            await this.CheckForExistingEntityOrExecutor();
                            resolve('success');
                        } else {
                            resolve('success');
                        }
                    } else {
                        this.isAPIAlreadyPresentCheckCompleted = true;
                        await this.CheckForExistingEntityOrExecutor();
                        resolve('success');
                    }
                } else {
                    resolve('success');
                }
            } else {
                resolve('failure');
            }
        });
    }

    setRequired(definition, event) {
        definition['required'] = event['checked'];
    }


    getXML() {
        const that = this;
        // xml = `<note><to>User</to><from>Library</from><heading>Message</heading><body>Some XML to convert to JSON!</body></note>`;
        const xml1 = $('.getXML').val().replace(/\s/g, '').trim();
        const parser = new DOMParser();
        const xml = parser.parseFromString(xml1, 'text/xml');
        const obj = this.ngxXml2jsonService.xmlToJson(xml);
        const crudAPI = {
            'entityname': that.entityName,
            'category': ((typeof that.apiCategory) === 'object' ? that.apiCategory['name'] : that.apiCategory),
            'displayname': that.displayName,
            'description': that.description,
            'published': that.ispublished,
            'scopeOfAccess': that.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': that.selectDatabase,
            'version': ((typeof that.version) === 'object' ? that.version['name'] : that.version),
            'attributes': obj
        };
        that.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            that.platform.openSnackBar('Entities Added successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            that.showNextPanel = true;

        }, error => {
            that.platform.handleErrorGracefully(error, 'Error while adding Entity. Please try again sometime.');
        });
    }

    createApiFromYaml() {
        this.confPost.createAPIFromYaml(localStorage.getItem('partner'), localStorage.getItem('account'), this.yamlData).subscribe(data => {
            this.platform.openSnackBar('APIs have been created from YAML successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.showNextPanel = true;

        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while creating APIs from YAML. Please try again sometime.');
        });
    }

    getJSON() {
        this.loading = true;
        this.save = false;
        const that = this;
        const crudAPI = {
            'entityname': this.entityName,
            'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayname': this.displayName,
            'description': this.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': this.selectDatabase,
            'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'attributes': this.editor.get()
        };
        if (this.isUseExistingTable === true) {
            crudAPI['tableCreation'] = false;
        } else {
            crudAPI['tableCreation'] = true;
        }
        this.confPost.insertEntity(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            if (data && data['message'] === 'API already exists.') {
                this.save = false;
                this.loading = false;
                this.platform.openSnackBar(data['message'], 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                if (this.ispublished) {
                    this.Blocks = [1, 2, 3, 4, 5];
                    const blockLength = this.Blocks.length;
                    const blockStart = this.BlockList[this.Blocks[0]];
                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    this.progress = blockStart;
                    this.save = true;
                    that.setInterval(blockEnd, true);
                } else {
                    this.Blocks = [1, 2, 3];
                    this.save = true;
                    const blockLength = this.Blocks.length;
                    const blockStart = this.BlockList[this.Blocks[0]];
                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    this.progress = blockStart;
                    that.setInterval(blockEnd, false);
                }
            }

        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while adding Entity. Please try again after sometime.');
        });
        if (this.ispublished) {
            // this.configureApiGateway();
            this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false);
        }
    }

    addHeaders() {
        const tr = '<tr>\n' +
            '              <td>\n' +
            '                <input type="text" placeholder="key" class="form-control">\n' +
            '              </td>\n' +
            '              <td>\n' +
            '                <input type="text" placeholder="value" class="form-control">\n' +
            '              </td>\n' +
            '              <td>\n' +
            '                <i class="fa fa-minus-square removeHeader"></i>\n' +
            '              </td>\n' +
            '            </tr>';
        $('#APIheader').find('tbody').append(tr);
    }

    copyMessage(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(val).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        // alert('CURL command copied to clipboard');
        this.platform.openSnackBar('CURL command copied to clipboard', 'Info', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    getAPI() {
        const that = this;
        this.loading = true;
        this.save = false;
        this.buttonClick = true;
        this.error = false;
        const APIUrl = $('#APIUrl').val();
        const dataroot = $('#dataroot').val();
        const Header = [];
        Header.push({
            'Content-Type': 'application/json'
        });
        $('#APIheader').find('tbody').find('tr').each(function () {
            const header = {};
            if ($(this).find('td:first').find('input').val().trim() !== '') {
                header[$(this).find('td:first').find('input').val().trim()] = $(this).find('td:eq(1)').find('input').val().trim();
                Header.push(header);
            }
        });
        const crudAPI = {
            'entityname': this.entityName,
            'importData': this.importData,
            'category': ((typeof this.apiCategory) === 'object' ? this.apiCategory['name'] : this.apiCategory),
            'tableName': this.tableName !== null ? this.tableName : this.account_id + '_' + this.entityName + '_' + ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'displayname': this.displayName,
            'description': this.description,
            'published': this.ispublished,
            'scopeOfAccess': this.scopeSelected,
            'creationTime': Date.now(),
            'lastModifiedTime': Date.now(),
            'registeredAsIs': false,
            'database': (this.selectDatabase === null ? 'default' : this.selectDatabase),
            'version': ((typeof this.version) === 'object' ? this.version['name'] : this.version),
            'APIUrl': APIUrl,
            'dataroot': dataroot,
            'Header': Header
        };
        if (this.isUseExistingTable === true) {
            crudAPI['tableCreation'] = false;
        } else {
            crudAPI['tableCreation'] = true;
        }
        this.confPost.createAPI(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            if (data && data['message'] === 'API already exists.') {
                this.save = false;
                this.loading = false;
                this.platform.openSnackBar(data['message'], 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            } else {
                if (this.ispublished) {
                    this.Blocks = [1, 2, 3, 4, 5];
                    const blockLength = this.Blocks.length;
                    const blockStart = this.BlockList[this.Blocks[0]];
                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    this.progress = blockStart;
                    this.save = true;
                    that.setInterval(blockEnd, true);
                    //  setInterval(() => this.manageProgress(blockEnd, false), 1000);
                } else {
                    this.Blocks = [1, 2, 3];
                    this.save = true;
                    const blockLength = this.Blocks.length;
                    const blockStart = this.BlockList[this.Blocks[0]];
                    const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    this.progress = blockStart;
                    that.setInterval(blockEnd, false);
                    // setInterval(() => this.manageProgress(blockEnd, false), 1000);
                    /* this.platform.openSnackBar('API has been created successfully', 'Success', {
                         duration: 5000,
                         verticalPosition: 'top',
                         horizontalPosition: 'center'
                     });*/
                }
            }
        }, error => {
            this.APILoading = true;
            this.error = true;
            this.platform.handleErrorGracefully(error, 'Error while creating API. Please try again after sometime.');
        });

        if (this.ispublished) {
            // this.configureApiGateway();
            this.kongService.configureApiGatewayWithIpRestriction(localStorage.getItem('partner'), localStorage.getItem('account'), this.entityName, ((typeof this.version) === 'object' ? this.version['name'] : this.version), false, false);

        }
    }

    navigateDataView() {
        this.router.navigate(['/api'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('account'),
                    entity: this.entityName,
                    version: this.version['name']
                }
            });
    }

    navigateAPIReview() {
        this.router.navigate(['/entity/edit'],
            {
                queryParams: {
                    partner: localStorage.getItem('partner'),
                    account: localStorage.getItem('account'),
                    entity: this.entityName,
                    version: this.version['name']
                }
            });
    }

    toggleExecutor(ev) {
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    manageProgress(target, showPanel) {
        // if (this.progress <= target) {
        //     this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
        //         let item = data;
        // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
        //     let apiKey = keys['data'][0].key;
        let apiKey = localStorage.getItem('apikey');
        const dialogRef = this.dialog.open(DialogComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
            data: {
                type: 'dataaccess',
                save: true,
                ispublished: this.ispublished,
                gatewayFullUrl: this.gatewayFullUrl,
                Blocks: this.Blocks,
                version: this.version,
                showNextPanel: false,
                partner: this.partner,
                account: this.account_id,
                entityName: this.entityName,
                apiKey: apiKey,
                partnerKey: this.partnerKey
            }
        });
        dialogRef.afterClosed().subscribe(async result => {
            if (result === 'create') {
                await this.router.navigateByUrl('/dataaccessapi');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else if (result === 'edit') {
                this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            } else if (result === 'data') {
                this.router.navigateByUrl('/api?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            } else if (result === 'devex') {
                this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
            }
        });
        // });
        // });
        // this.showNextPanel = showPanel;
        this.loading = false;
        this.ngOnDestroy();
        // } else {
        //     this.progress = this.progress + incr;
        // }
        // if (this.progress <= 35) {
        //     this.progressMessage = 'Setting Up API';
        // } else if (this.progress > 35 && this.progress <= 70) {
        //     this.progressMessage = 'Setting Up Database';
        //     /*} else if (this.progress > 70 && this.progress <= 98) {
        //         this.progressMessage = 'Creating dedicated File storage for your account';*/
        // } else if (this.progress > 70) {
        //     this.progressMessage = 'Deploying into Cloud';
        // }
    }

    async editAPI() {
        this.router.navigateByUrl('/entity/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
    }

    manageData() {
        this.router.navigateByUrl('/api?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
    }

    manageDocumentation() {
        this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.entityName + '&version=' + this.version);
    }

    manageProgressForApi() {
        if (this.progress >= 100) {
            // this.APILoading = true;
            this.showNextPanel = true;
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up API & Schema';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Data';
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    createAPIByDB() {
        this.buttonClickdB = true;
        this.dberror = false;
        const crudAPI = {
            'database_name': this.databaseName,
            'listOfTables': this.listofTables,
            'useReferentialKeys': this.useReferentialKeys,
            'targetDatabase': (this.targetDatabase == null ? 'default' : this.targetDatabase),
            'importData': this.importDataDB
        };
        if (this.isUseExistingTable === true) {
            crudAPI['tableCreation'] = false;
        } else {
            crudAPI['tableCreation'] = true;
        }
        this.confPost.createAPIFromDB(localStorage.getItem('partner'), localStorage.getItem('account'), crudAPI).subscribe(data => {
            this.platform.openSnackBar('API Created successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.APILoadingdB = true;

        }, error => {
            this.dberror = true;
            this.APILoadingdB = true;
            this.platform.handleErrorGracefully(error, 'Error while creating API. Please try again after sometime.');
        });
    }

    isFamilyString(type, datatypeFilter): boolean {
        let matched = false;
        this.dataTypeFilter = datatypeFilter;
        if (this.dataTypeFilter) {
            for (let i = 0; i < this.dataTypeFilter.length; i++) {
                if (this.dataTypeFilter[i]['data_types'][0]['type'] === type) {
                    if (this.dataTypeFilter[i]['data_types'][0]['family'] === 'String') {
                        matched = true;
                        return true;
                    }
                }
            }
            if (matched === false) {
                return false;
            }
        }
    }

    openAttributeDescriptionDialog(definition) {
        const data = {
            'displayName': definition.displayName,
            'description': definition.description,
            'dataStoragePolicy': definition.dataStoragePolicy,
            'apiAccessPolicy': definition.apiAccessPolicy,
            'displayPolicy': definition.displayPolicy,
            'definitionType': definition.type,
            'compliances': definition.compliances ? definition.compliances : [],
            'datatypeFilter': this.dataTypeFilter
        };
        const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
            this.accept = result;
            definition.displayName = data.displayName;
            definition.description = data.description;
            definition.dataStoragePolicy = data.dataStoragePolicy;
            definition.apiAccessPolicy = data.apiAccessPolicy;
            definition.displayPolicy = data.displayPolicy;
            definition.compliances = data.compliances;
        });
    }

    private _filter(name: string): ICategory[] {
        const filterValue = name.toLowerCase();

        return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private _versionFilter(name: string): EntityVersions[] {
        const filterValue = name.toLowerCase();

        return this.entityVersions.filter(version => version.name.toLowerCase().indexOf(filterValue) === 0);
    }

    getRegion(val) {
        return this.platform.getRegion(val);
    }

    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
    }

    generateExecutorAgain() {
        window.location.reload();
    }

    // Data Access API - Data Types Descriptions
    getDescription(dataType) {
        if (dataType) {
            for (let item of this.dataTypesDescriptions) {
                if (this.selectedDatatypeFilter == item.database_type) {
                    for (let type of item.dataTypes) {
                        if (type.dataType.toLowerCase() === dataType.toLowerCase())
                            return type.description;
                    }
                }
            }
        }
    }

    createMarginRight() {
        document.getElementById('view:data_access_api').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:data_access_api').style.marginRight = '0';
    }
}

@Component({
    selector: 'attribute-description-dialog',
    templateUrl: 'attribute-description.component.html',
    styleUrls: ['attribute-description.component.css']
})
export class AttributeDescriptionComponent {

    datastoragepolicy = ['None', 'Encrypted'];
    apiaccesspolicy = ['None', 'Decrypted', 'Encrypted', 'Masked (All with X)', 'Masked (All with x)', 'Masked (All with *)', 'Masked (xxxx-xxxx-xxxx-####)', 'Masked (xxxxxxxxxxxx####)'];
    displaypolicy = ['None', 'Decrypted', 'Encrypted', 'Masked'];

    compliances = [
        {
            display_name: 'Protected Health Information',
            value: {
                name: 'PHI',
                config: null
            }
        }
    ];

    selectedCompliances = [];

    constructor(
        public platform: LeftpanelComponent, public crudapiInstance: CrudapiComponent,
        public dialogRef: MatDialogRef<AttributeDescriptionComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {

        if (data['compliances']) {
            for (const val of data['compliances']) {
                for (const val2 of this.compliances) {
                    if (val2.value.name === val.name) {
                        this.selectedCompliances.push(val.name);
                        break;
                    }
                }
            }
        }
    }

    complianceChange() {
        this.data['compliances'] = [];
        if (this.selectedCompliances) {
            for (const compliance of this.selectedCompliances) {
                const index = this.compliances.findIndex(p => p.value.name === compliance);
                if (index !== -1) {
                    this.data['compliances'].push(this.compliances[index].value);
                }
            }
        }
    }
}

@Component({
    selector: 'use-existing-table-confirmation',
    templateUrl: 'use-existing-table-confirmation.component.html',
    styleUrls: ['use-existing-table-confirmation.component.css']
})
export class UseExistingTableConfirmationComponent implements OnInit {

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<AddGatewayResourceComponent>, public confPost: ConfService, public router: Router, public kongService: KongService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {

    }

    useTable() {
        this.dialogRef.close('yes');
    }

    close() {
        this.dialogRef.close();
    }
}
